import React, { useEffect } from 'react';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';

export const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page" data-testid="terms-page">
      <SiteHeader />

      <section className="page-content-section">
        <div className="container page-container-inner">
          <div className="legal-content" data-testid="terms-content">
              <h1 className="legal-title">BuckTime! Terms of Service</h1>
              <p className="legal-meta">Effective Date: March 6, 2026 | Last Updated: August 31, 2026</p>

              <h2>ACCEPTANCE OF TERMS</h2>
              <h3>1.1 Agreement to These Terms</h3>
              <p>Welcome to BuckTime! . These Terms of Service (the &quot;Terms&quot;) constitute a legally binding agreement between you and 2422019 Ontario Inc. (o/a BuckTime!) (&quot;BuckTime!&quot;, &quot;Company&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) governing your access to and use of the BuckTime! mobile application, website, software, content, features, services, and related technologies (collectively, the &quot;App&quot;).</p>
              <p>By downloading, installing, accessing, browsing, registering for, activating, or using the App, you acknowledge that you have read, understood, and agree to be bound by:</p>
              <ul>
                <li>these Terms;</li>
                <li>the Privacy Policy;</li>
                <li>any supplemental terms applicable to specific features;</li>
                <li>any applicable app-store terms and conditions; and</li>
                <li>any policies incorporated into these Terms by reference.</li>
              </ul>
              <p>If you do not agree to these Terms, you must not access or use the App.</p>
              <h3>1.2 Acceptance on Behalf of a Child</h3>
              <p>The App is designed to facilitate use by families and may permit the creation of Child Profiles.</p>
              <p>Where you create, manage, or authorize a Child Profile, you acknowledge and agree that:</p>
              <ul>
                <li>(a) you are acting in your capacity as the child’s parent, legal guardian, or other legally authorized decision-maker;</li>
                <li>(b) you have authority to accept these Terms on behalf of the child to the extent legally permitted;</li>
                <li>(c) you consent to the collection, use, disclosure, storage, processing, and transfer of information relating to the child as described in these Terms and the Privacy Policy; and</li>
                <li>(d) you assume responsibility for the child’s use of the App.</li>
              </ul>
              <p>To the extent permitted by applicable law, references in these Terms to &quot;you&quot; include both the Parent Account holder and any Child Profile administered by that Parent Account holder.</p>
              <h3>1.3 Electronic Acceptance</h3>
              <p>These Terms are accepted electronically.</p>
              <p>Your acceptance is evidenced by any of the following actions:</p>
              <ul>
                <li>creating an account;</li>
                <li>clicking an &quot;Accept,&quot; &quot;Agree,&quot; &quot;Continue,&quot; &quot;Create Account,&quot; or similar button;</li>
                <li>downloading the App;</li>
                <li>installing the App;</li>
                <li>accessing the App;</li>
                <li>using any feature of the App; or</li>
                <li>otherwise indicating acceptance electronically.</li>
              </ul>
              <p>You agree that electronic acceptance has the same legal effect as a handwritten signature and creates a legally binding agreement.</p>
              <h3>1.4 App Store Distribution</h3>
              <p>The App may be distributed through third-party marketplaces, including:</p>
              <ul>
                <li>the Apple App Store;</li>
                <li>Google Play Store; and</li>
                <li>other authorized distribution platforms.</li>
              </ul>
              <p>Your use of the App may also be subject to the terms, conditions, policies, and requirements of those marketplaces.</p>
              <p>Nothing in these Terms modifies any mandatory rights or obligations imposed by the applicable marketplace.</p>
              <p>To the extent of any conflict between these Terms and mandatory marketplace requirements, the mandatory marketplace requirements shall prevail.</p>
              <h3>1.5 Future Features and Services</h3>
              <p>Certain features described in these Terms may not be available at the time you first use the App.</p>
              <p>The Company may:</p>
              <ul>
                <li>introduce new features;</li>
                <li>modify existing features;</li>
                <li>discontinue features;</li>
                <li>introduce subscription services;</li>
                <li>introduce payment functionality;</li>
                <li>introduce third-party integrations; or</li>
                <li>otherwise change the functionality of the App.</li>
              </ul>
              <p>Additional features may be subject to supplemental terms, disclosures, permissions, notices, or consent requirements.</p>
              <h3>1.6 Electronic Communications</h3>
              <p>By creating an account or using the App, you consent to receive electronic communications from the Company, including:</p>
              <ul>
                <li>legal notices;</li>
                <li>account notifications;</li>
                <li>service announcements;</li>
                <li>security alerts;</li>
                <li>billing notices;</li>
                <li>support communications;</li>
                <li>policy updates; and</li>
                <li>other communications relating to the App.</li>
              </ul>
              <p>Such communications may be delivered by:</p>
              <ul>
                <li>email;</li>
                <li>push notification;</li>
                <li>in-app message;</li>
                <li>website posting; or</li>
                <li>other electronic means.</li>
              </ul>
              <p>You agree that electronic communications satisfy any legal requirement that such communications be in writing.</p>
              <h3>1.7 Modifications to These Terms</h3>
              <p>The Company may modify these Terms from time to time.</p>
              <p>Where a change materially affects user rights or obligations, the Company will make reasonable efforts to provide advance notice through one or more of the following methods:</p>
              <ul>
                <li>email;</li>
                <li>push notification;</li>
                <li>in-app notice;</li>
                <li>website posting; or</li>
                <li>other reasonable means.</li>
              </ul>
              <p>The period of notice provided may vary depending upon the nature of the change and applicable legal requirements.</p>
              <p>Your continued access to or use of the App following the effective date of revised Terms constitutes acceptance of the revised Terms.</p>
              <p>If you do not agree to revised Terms, you must discontinue use of the App before the revised Terms become effective.</p>
              <h3>1.8 Suspension of Access</h3>
              <p>The Company reserves the right to suspend, restrict, or terminate access to the App where:</p>
              <ul>
                <li>required by law;</li>
                <li>necessary to protect users;</li>
                <li>necessary to protect children;</li>
                <li>necessary to maintain security;</li>
                <li>necessary to investigate violations of these Terms; or</li>
                <li>otherwise reasonably necessary to protect the Company, its users, or the integrity of the App.</li>
              </ul>
              <h3>1.9 Severability</h3>
              <p>If any provision of these Terms is determined to be invalid, illegal, unenforceable, or contrary to applicable law, that provision shall be modified or severed to the minimum extent necessary, and the remaining provisions shall continue in full force and effect.</p>
              <h3>1.10 Entire Agreement</h3>
              <p>These Terms, together with the Privacy Policy and any supplemental terms incorporated by reference, constitute the entire agreement between you and the Company concerning the App and supersede all prior understandings, communications, representations, and agreements relating to the App.</p>
              <h3>1.11 Definitions</h3>
              <p>For the purposes of these Terms, the following definitions apply:</p>
              <p>&quot;Active Boost&quot; means any feature that rewards, measures, tracks, or incorporates physical activity information, including step counts, active minutes, movement goals, activity multipliers, or similar activity-based incentives.</p>
              <p>&quot;Active Guard&quot; means the Company’s monitoring functionality that is designed to assist Parent Account holders in determining whether designated Monitored Apps have been accessed during a Focus Window. Active Guard is subject to technical limitations and does not guarantee complete accuracy.</p>
              <p>&quot;App&quot; means the BuckTime! mobile application, website, software, content, features, services, technology, analytics tools, support services, and related functionality made available by the Company.</p>
              <p>&quot;Child Profile&quot; means a profile created and administered by a Parent Account holder for a child under the Parent Account holder’s supervision.</p>
              <p>&quot;Company&quot;, &quot;BuckTime!&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot; means 2422019 Ontario Inc. (o/a BuckTime!), together with its affiliates, successors, and assigns.</p>
              <p>&quot;Emergency Token&quot; means a virtual item, reward, permission, or feature that may permit temporary access to designated functionality without affecting certain earning calculations or restrictions.</p>
              <p>&quot;Exclusion Window&quot; means a period designated by a Parent Account holder during which monitoring, earning calculations, or reward accumulation may be suspended, modified, or disregarded.</p>
              <p>&quot;Family Group&quot; means a collection of Parent Accounts, Child Profiles, Linked Devices, and related settings associated with a household or family unit.</p>
              <p>&quot;Focus Window&quot; (referred to in the app as “Buck Breaks”) means a period designated by a Parent Account holder during which Active Guard attempts to determine whether Monitored Apps have been accessed for purposes of earning calculations, analytics, rewards, or other App functionality.</p>
              <p>&quot;Gift Gem&quot; means a virtual item, digital reward, token, badge, or similar in-App item that may be awarded, earned, purchased, or otherwise made available through the App.</p>
              <p>&quot;Ledger&quot; means the informational record maintained within the App reflecting earnings, rewards, incentives, allowances, bonuses, multipliers, adjustments, or other entries associated with a Child Profile. The Ledger is informational only and does not represent money, stored value, funds held by the Company, or any regulated financial product.</p>
              <p>&quot;Linked Device&quot; means any smartphone, tablet, computer, gaming device, wearable device, or other supported device connected to a Family Group or Child Profile.</p>
              <p>&quot;Monitored App&quot; means an application, application category, website, service, platform, or other digital activity designated by a Parent Account holder for monitoring during a Focus Window.</p>
              <p>&quot;Parent Account&quot; means the primary account established by a parent, legal guardian, or other authorized individual that administers one or more Child Profiles.</p>
              <p>&quot;Parent Account Holder&quot; means the individual who creates, controls, administers, or manages a Parent Account.</p>
              <p>&quot;Personal Information&quot; has the meaning assigned under applicable privacy legislation and generally means information about an identifiable individual.</p>
              <p>&quot;Privacy Policy&quot; means the Company’s privacy policy, as amended from time to time.</p>
              <p>&quot;Subscription&quot; means any recurring paid plan, premium service, membership, or paid access program offered by the Company.</p>
              <p>&quot;Terms&quot; means these Terms of Service, as amended from time to time.</p>
              <p>&quot;Third-Party Provider&quot; means any external service provider, marketplace operator, operating-system provider, payment processor, analytics provider, cloud-hosting provider, authentication provider, or other third party whose products or services may be used in connection with the App.</p>
              <p>&quot;Usage Data&quot; means information generated through use of the App, including analytics, performance information, device information, configuration information, activity metrics, and other operational information that does not necessarily identify an individual.</p>
              <p>&quot;User&quot;, &quot;you&quot;, or &quot;your&quot; means any person who accesses, downloads, installs, registers for, uses, administers, or otherwise interacts with the App, including Parent Account holders and Child Profiles where applicable.</p>
              <p>&quot;Virtual Item&quot; means any digital item, token, reward, badge, streak, achievement, Emergency Token, Gift Gem, cosmetic item, avatar enhancement, virtual currency, or other digital content made available through the App.</p>
              <p>&quot;Working Day&quot; means any day other than a Saturday, Sunday, or statutory holiday observed in Ontario, Canada.</p>
              <p>2. Eligibility and Account Types</p>
              <h3>2.1 Eligibility Requirements</h3>
              <p>To create and maintain a Parent Account, you must:</p>
              <ul>
                <li>be at least eighteen (18) years of age or the age of majority in your jurisdiction, whichever is greater;</li>
                <li>possess the legal capacity to enter into a binding agreement;</li>
                <li>reside in a jurisdiction where use of the App is lawful;</li>
                <li>have authority to enter into these Terms;</li>
                <li>comply with all applicable laws relating to the use of the App; and</li>
                <li>satisfy any identity, account-verification, parental-verification, or eligibility requirements that the Company may establish from time to time.</li>
              </ul>
              <p>The Company reserves the right to refuse registration, suspend access, require additional verification, or terminate any account that does not satisfy these eligibility requirements.</p>
              <h3>2.2 Parent Accounts</h3>
              <p>Parent Accounts are intended solely for use by parents, legal guardians, or other persons legally authorized to supervise a child and provide the consents required under applicable law.</p>
              <p>By creating a Parent Account, you represent, warrant, and covenant that:</p>
              <ul>
                <li>(a) you are the parent, legal guardian, or other legally authorized decision-maker for each child associated with the account;</li>
                <li>(b) you possess all authority necessary to provide consent on behalf of each child whose information is submitted to the App;</li>
                <li>(c) all information you provide is accurate, current, complete, and not misleading;</li>
                <li>(d) you will maintain the confidentiality of your account credentials and will promptly notify the Company of any unauthorized access to your account;</li>
                <li>(e) you will use the App only in accordance with these Terms and applicable law; and</li>
                <li>(f) you will supervise all Child Profiles associated with your Parent Account.</li>
              </ul>
              <p>The Parent Account holder remains solely responsible for all activity occurring through the Parent Account and any associated Child Profiles.</p>
              <h3>2.3 Child Profiles</h3>
              <p>Child Profiles may only be created by a Parent Account holder.</p>
              <p>Children may not independently register for the App, establish an account, create a Child Profile, or knowingly submit personal information directly to the Company without parental authorization.</p>
              <p>By creating a Child Profile, you represent and warrant that:</p>
              <ul>
                <li>(a) you have legal authority to act on behalf of the child;</li>
                <li>(b) you have authority to provide all necessary privacy consents relating to the child;</li>
                <li>(c) you have authority to authorize the monitoring functionality described in these Terms;</li>
                <li>(d) you have reviewed these Terms and the Privacy Policy and consent to the Company’s collection, use, disclosure, storage, processing, and transfer of the child’s information as described therein;</li>
                <li>(e) the information provided regarding the child is accurate and complete; and</li>
                <li>(f) the child’s use of the App will remain subject to your supervision and control.</li>
              </ul>
              <p>The Company may rely upon the representations made by the Parent Account holder without conducting an independent investigation.</p>
              <h3>2.4 Multiple Parents and Guardians</h3>
              <p>Where more than one parent, guardian, or person possesses legal decision-making authority concerning a child, the individual creating the Child Profile represents and warrants that they possess all required authority and consents necessary to authorize the child’s participation in the App.</p>
              <p>The Company is not responsible for determining parental rights, custody arrangements, guardianship disputes, decision-making authority, parenting orders, court orders, separation agreements, or family-law disputes.</p>
              <p>If the Company becomes aware of a dispute regarding parental authority, consent, guardianship, custody, or decision-making rights, the Company may:</p>
              <ul>
                <li>suspend the affected Child Profile;</li>
                <li>suspend the Parent Account;</li>
                <li>request additional documentation;</li>
                <li>restrict access to certain features; or</li>
                <li>terminate the account pending resolution of the dispute.</li>
              </ul>
              <p>The Company shall have no obligation to adjudicate disputes between parents, guardians, or family members.</p>
              <h3>2.5 Parental Consent and Verification</h3>
              <p>The App is intended for family use and is designed primarily for children between the ages of 6 and 17 years.</p>
              <p>The Company does not knowingly permit children to create independent accounts and does not knowingly collect personal information directly from children without parental authorization.</p>
              <p>The Company reserves the right to implement reasonable parental-consent verification procedures, including:</p>
              <ul>
                <li>email verification;</li>
                <li>account verification;</li>
                <li>payment-card verification;</li>
                <li>identity verification;</li>
                <li>documentation requests;</li>
                <li>parental confirmation procedures; and</li>
                <li>any other method permitted by applicable law.</li>
              </ul>
              <p>The Company may suspend, restrict, or terminate access if required verification is not completed or cannot be reasonably established.</p>
              <h3>2.6 Withdrawal of Consent</h3>
              <p>A Parent Account holder may withdraw consent for a Child Profile at any time by deleting the Child Profile through the App or by contacting the Company.</p>
              <p>Withdrawal of consent may result in:</p>
              <ul>
                <li>suspension of the Child Profile;</li>
                <li>termination of access to certain features;</li>
                <li>deletion of personal information; and</li>
                <li>closure of the associated Child Profile.</li>
              </ul>
              <p>Certain information may be retained following withdrawal of consent where required by law or reasonably necessary for security, fraud prevention, legal compliance, dispute resolution, backup integrity, or enforcement of these Terms.</p>
              <h3>2.7 Child Privacy Rights</h3>
              <p>Subject to applicable law and reasonable identity-verification procedures, the Parent Account holder may request:</p>
              <ul>
                <li>access to personal information associated with a Child Profile;</li>
                <li>correction of inaccurate information;</li>
                <li>export of certain information;</li>
                <li>deletion of personal information; and</li>
                <li>withdrawal of consent for continued processing.</li>
              </ul>
              <p>Requests may be submitted through the App or by contacting support@chachingapp.ca.</p>
              <p>The Company reserves the right to verify the identity and authority of the requesting individual before responding to any request.</p>
              <h3>2.8 Unauthorized Child Accounts</h3>
              <p>If the Company learns or reasonably suspects that a child has created an account independently, submitted information without parental authorization, or otherwise accessed the App contrary to these Terms, the Company may:</p>
              <ul>
                <li>suspend or terminate the account;</li>
                <li>remove associated information;</li>
                <li>request parental authorization;</li>
                <li>restrict access to functionality; or</li>
                <li>take any other action reasonably necessary to comply with applicable law.</li>
              </ul>
              <p>The Company will take reasonable steps to investigate and address such situations in accordance with applicable privacy laws.</p>
              <h3>2.9 No Reliance on Age Information Alone</h3>
              <p>The Company may rely upon information provided by users concerning age, identity, parental authority, and legal capacity.</p>
              <p>However, the Company reserves the right to request additional information, documentation, or verification where the Company reasonably believes that eligibility, parental authority, age, consent, or legal capacity may be in question.</p>
              <p>Failure to provide requested verification may result in suspension or termination of access to the App.</p>
              <p>3. The Active Guard — Passive Monitoring System</p>
              <h3>3.1 Overview of Active Guard</h3>
              <p>Active Guard is a parental-assistance feature designed to help parents and legal guardians encourage healthy device habits and reduce distracting screen time during designated Focus Windows.</p>
              <p>When enabled by a Parent Account holder and properly configured on a Linked Device, Active Guard attempts to determine whether applications designated as Monitored Apps have been opened or used during an active Focus Window.</p>
              <p>Active Guard operates only after the permissions required by the applicable operating system have been granted and maintained by the Parent Account holder. The functionality, availability, accuracy, and performance of Active Guard may vary depending upon the operating system, device manufacturer, software version, device settings, permissions, network connectivity, and third-party platform restrictions.</p>
              <p>Active Guard is intended as a family-management and parental-assistance tool only. It is not designed, marketed, or intended to function as surveillance software, spyware, employee-monitoring software, or covert tracking technology.</p>
              <h3>3.2 Authorized Use</h3>
              <p>Active Guard may only be used by:</p>
              <ul>
                <li>(a) a parent or legal guardian monitoring a child under their care;</li>
                <li>(b) a person otherwise legally authorized to supervise the child and provide the necessary consents under applicable law.</li>
              </ul>
              <p>You may not install, configure, or use Active Guard on any device without the knowledge and authorization of the device user and any legally required consent.</p>
              <p>You represent and warrant that you possess all necessary rights, consents, permissions, and legal authority required to use Active Guard with respect to each Child Profile and Linked Device.</p>
              <h3>3.3 Scope of Monitoring</h3>
              <p>Subject to device capabilities and operating-system limitations, Active Guard is designed to determine whether a Monitored App has been opened, launched, activated, or brought into the foreground during a Focus Window.</p>
              <p>Except as expressly disclosed in these Terms and the Privacy Policy, Active Guard is not designed to:</p>
              <ul>
                <li>read text messages, emails, or private communications;</li>
                <li>record telephone calls, video calls, or voice communications;</li>
                <li>access the contents of applications;</li>
                <li>record screen contents;</li>
                <li>capture screenshots;</li>
                <li>record keystrokes;</li>
                <li>monitor passwords;</li>
                <li>access photographs, videos, or personal files;</li>
                <li>access contact lists;</li>
                <li>collect GPS location information; or</li>
                <li>collect browsing history.</li>
              </ul>
              <p>The Company does not intentionally collect or review the content viewed, created, received, or transmitted within third-party applications.</p>
              <h3>3.4 Technical Limitations</h3>
              <p>Active Guard relies upon operating-system permissions, APIs, background-processing privileges, and technical capabilities provided by device manufacturers and platform providers, including but not limited to Android and Apple.</p>
              <p>The Company does not control such third-party systems and cannot guarantee that Active Guard will:</p>
              <ul>
                <li>detect all instances of Monitored App usage;</li>
                <li>operate continuously without interruption;</li>
                <li>remain compatible with all devices;</li>
                <li>remain compatible following operating-system updates;</li>
                <li>produce completely accurate results in all circumstances; or</li>
                <li>function identically across all platforms and devices.</li>
              </ul>
              <p>Parents and guardians acknowledge that device settings, battery-management features, operating-system restrictions, software updates, permission changes, hardware limitations, network interruptions, user actions, and third-party platform changes may affect the operation of Active Guard.</p>
              <h3>3.5 Focus Windows</h3>
              <p>Parents may establish one or more Focus Windows during which Active Guard attempts to monitor activity relating to Monitored Apps.</p>
              <p>Parents may also establish Exclusion Windows, including school hours, sleep periods, extracurricular activities, vacations, or other periods during which earning opportunities may be suspended or modified.</p>
              <p>The Parent Account holder is solely responsible for configuring Focus Windows, Exclusion Windows, Monitored Apps, earning criteria, and related settings.</p>
              <h3>3.6 Earning Determinations</h3>
              <p>Active Guard is intended to assist in determining whether earning criteria established by the Parent Account holder have been satisfied.</p>
              <p>All Ledger entries, earning calculations, streak calculations, reward calculations, and related analytics are generated automatically using information available to the App and may contain inaccuracies resulting from technical limitations.</p>
              <p>The Parent Account holder remains solely responsible for determining whether a child has earned an allowance, reward, privilege, or benefit and may modify, override, or disregard any earning determination generated by the App.</p>
              <h3>3.7 Cross-Device Monitoring</h3>
              <p>The App may permit the linking of multiple devices to a Family Group, including smartphones, tablets, computers, gaming devices, and other supported devices.</p>
              <p>Availability of monitoring functionality varies by platform and device type. Certain monitoring features may not be available on all devices and may change without notice due to operating-system updates or platform-provider restrictions.</p>
              <p>The Parent Account holder is responsible for ensuring that Linked Devices are properly configured and remain authorized for use with the App.</p>
              <h3>3.8 No Substitute for Parental Supervision</h3>
              <p>Active Guard is intended solely as a supplemental parental-assistance tool.</p>
              <p>The Company does not represent or warrant that use of Active Guard will:</p>
              <ul>
                <li>reduce screen time;</li>
                <li>improve academic performance;</li>
                <li>improve behaviour;</li>
                <li>improve attention or concentration;</li>
                <li>improve family relationships;</li>
                <li>prevent access to inappropriate content; or</li>
                <li>achieve any specific parenting, educational, behavioural, developmental, or health-related outcome.</li>
              </ul>
              <p>Parents and guardians remain solely responsible for supervising their children and making all parenting decisions relating to device usage, screen time, allowances, rewards, and discipline.</p>
              <h3>3.9 Future Functionality</h3>
              <p>The Company may modify, expand, limit, suspend, or discontinue Active Guard or any component of Active Guard at any time.</p>
              <p>Additional monitoring features, device integrations, or functionality introduced in future releases may be subject to supplemental terms, notices, permissions, disclosures, or consent requirements.</p>
              <p>4. Allowance, Earnings, and Settlement</p>
              <h3>4.1 Parent-Controlled Earning Programs</h3>
              <p>BuckTime! provides tools that permit Parent Account holders to establish household reward programs, allowances, incentives, and earning opportunities for children.</p>
              <p>The Parent Account holder has sole discretion to determine:</p>
              <ul>
                <li>earning rates;</li>
                <li>weekly, monthly, or other earning caps;</li>
                <li>reward structures;</li>
                <li>Focus Window requirements;</li>
                <li>bonus opportunities;</li>
                <li>penalty rules;</li>
                <li>Active Boost multipliers;</li>
                <li>redemption criteria; and</li>
                <li>any other earning-related settings.</li>
              </ul>
              <p>BuckTime! does not recommend, determine, guarantee, or approve any particular allowance, reward, or compensation structure.</p>
              <p>The Parent Account holder remains solely responsible for all decisions relating to rewards, allowances, incentives, privileges, and compensation provided to a child.</p>
              <h3>4.2 Informational Nature of the Ledger</h3>
              <p>The Ledger is an informational record maintained within the App for the convenience of the Parent Account holder and Child Profile.</p>
              <p>The Ledger is intended solely to display earning information generated through the App and does not constitute:</p>
              <ul>
                <li>a bank account;</li>
                <li>a deposit account;</li>
                <li>a trust account;</li>
                <li>a custodial account;</li>
                <li>a stored-value account;</li>
                <li>an electronic money account;</li>
                <li>a prepaid account;</li>
                <li>a securities account;</li>
                <li>an investment account; or</li>
                <li>any other regulated financial product.</li>
              </ul>
              <p>Ledger balances are bookkeeping records only and represent neither money held by BuckTime! nor any legally segregated funds.</p>
              <p>No funds are deposited with, received by, held by, managed by, invested by, or controlled by BuckTime! on behalf of any user.</p>
              <h3>4.3 No Financial Institution Relationship</h3>
              <p>BuckTime! is not a bank, credit union, trust company, money-services business, payment processor, securities dealer, investment adviser, financial institution, or provider of regulated financial services.</p>
              <p>Nothing contained within the App creates:</p>
              <ul>
                <li>a fiduciary relationship;</li>
                <li>a trustee-beneficiary relationship;</li>
                <li>a custodial relationship;</li>
                <li>a debtor-creditor relationship;</li>
                <li>an investment relationship; or</li>
                <li>any obligation by BuckTime! to pay, transfer, safeguard, or hold funds.</li>
              </ul>
              <p>Any obligation to provide an allowance, reward, incentive, gift, or payment remains solely between the Parent Account holder and the child.</p>
              <h3>4.4 Settlement Between Parent and Child</h3>
              <p>Amounts reflected in the Ledger represent the App’s automated calculation of earnings based upon the earning criteria established by the Parent Account holder.</p>
              <p>The Parent Account holder remains solely responsible for determining:</p>
              <ul>
                <li>whether earnings should be paid;</li>
                <li>the amount to be paid;</li>
                <li>the timing of payment;</li>
                <li>the payment method; and</li>
                <li>whether any Ledger entry should be adjusted, overridden, reduced, increased, or disregarded.</li>
              </ul>
              <p>BuckTime! is not a party to any arrangement between a parent and child concerning allowances, rewards, incentives, gifts, or payments.</p>
              <p>Any dispute concerning amounts shown in the Ledger shall be resolved solely between the Parent Account holder and the child.</p>
              <h3>4.5 Payment Convenience Features</h3>
              <p>The App may provide convenience features that permit a Parent Account holder to launch or connect with third-party applications, including:</p>
              <ul>
                <li>banking applications;</li>
                <li>electronic payment applications;</li>
                <li>money-transfer services;</li>
                <li>messaging applications;</li>
                <li>digital wallet applications; and</li>
                <li>other third-party services.</li>
              </ul>
              <p>Such features are provided solely for convenience.</p>
              <p>BuckTime!:</p>
              <ul>
                <li>does not process payments;</li>
                <li>does not receive payment instructions;</li>
                <li>does not transmit funds;</li>
                <li>does not verify recipient information;</li>
                <li>does not guarantee transaction completion; and</li>
                <li>does not monitor whether a payment was successfully completed.</li>
              </ul>
              <p>All payment activity conducted through third-party applications remains subject to the terms, policies, security procedures, and operational practices of those third parties.</p>
              <h3>4.6 Earning Calculations and Technical Limitations</h3>
              <p>Earning calculations are generated automatically based upon information available to the App.</p>
              <p>The Company does not guarantee that earning calculations, streak calculations, focus metrics, Active Boost calculations, analytics, reports, or Ledger entries will be free from error.</p>
              <p>Calculation results may be affected by:</p>
              <ul>
                <li>device limitations;</li>
                <li>operating-system restrictions;</li>
                <li>permission settings;</li>
                <li>network interruptions;</li>
                <li>software defects;</li>
                <li>platform-provider changes;</li>
                <li>synchronization delays;</li>
                <li>inaccurate device data; and</li>
                <li>other technical factors beyond the Company’s control.</li>
              </ul>
              <p>Parents should independently review earning results before making payment decisions.</p>
              <h3>4.7 No Guarantee of Earnings</h3>
              <p>BuckTime! does not guarantee that a child will earn any specific amount through use of the App.</p>
              <p>Actual earnings depend upon:</p>
              <ul>
                <li>settings selected by the Parent Account holder;</li>
                <li>child behaviour;</li>
                <li>monitoring accuracy;</li>
                <li>device functionality;</li>
                <li>operating-system compatibility; and</li>
                <li>other factors outside the Company’s control.</li>
              </ul>
              <p>The Company makes no representation that any child will achieve any particular earning outcome, allowance amount, reward level, savings goal, behavioural outcome, educational outcome, or financial result.</p>
              <h3>4.8 Active Boost Rewards</h3>
              <p>Where Active Boost is enabled, activity-based multipliers or rewards may be generated based upon activity information made available by supported device sensors and operating-system services.</p>
              <p>Active Boost is intended solely as a motivational and reward feature.</p>
              <p>Active Boost is not:</p>
              <ul>
                <li>a medical device;</li>
                <li>a health-monitoring service;</li>
                <li>a fitness coaching service;</li>
                <li>a diagnostic tool; or</li>
                <li>a substitute for professional medical advice.</li>
              </ul>
              <p>The Company does not guarantee the accuracy of step counts, activity measurements, exercise calculations, calories, active minutes, or related activity information.</p>
              <h3>4.9 Future Payment Integrations</h3>
              <p>The Company may introduce integrated payment functionality in future versions of the App.</p>
              <p>Such functionality may involve third-party payment processors, financial institutions, digital wallet providers, app-store billing services, or other payment providers.</p>
              <p>Prior to activation of any integrated payment functionality, the Company may require users to:</p>
              <ul>
                <li>accept supplemental terms;</li>
                <li>provide additional consents;</li>
                <li>complete identity verification procedures;</li>
                <li>satisfy age requirements;</li>
                <li>comply with applicable legal requirements; and</li>
                <li>agree to the terms of third-party providers.</li>
              </ul>
              <p>The Company reserves the right to modify, suspend, decline, or discontinue any future payment-related functionality at any time.</p>
              <h3>4.10 Taxes</h3>
              <p>The Parent Account holder remains solely responsible for determining whether any tax, reporting, accounting, family-law, employment, trust, gift, educational, or other legal implications arise from allowances, rewards, incentives, gifts, or payments provided to a child.</p>
              <p>BuckTime! provides no tax, accounting, legal, investment, financial, or other professional advice.</p>
              <p>5. Subscriptions and In-App Purchases</p>
              <h3>5.1 Future Paid Features</h3>
              <p>Certain features described in this Section are not active as of the Effective Date of these Terms.</p>
              <p>The Company may introduce subscription plans, premium features, in-app purchases, virtual items, rewards programs, family plans, payment integrations, or other paid functionality in future versions of the App.</p>
              <p>Prior to activation of any paid feature, the Company will provide appropriate notice within the App and update these Terms, the Privacy Policy, and any applicable pricing disclosures.</p>
              <p>Nothing in this Section obligates the Company to offer any paid feature, maintain any pricing structure, or continue any specific feature for any period of time.</p>
              <h3>5.2 Subscription Plans</h3>
              <p>The Company may offer one or more subscription plans, including family plans, premium plans, enhanced analytics plans, or other subscription services.</p>
              <p>Subscription features, pricing, billing frequency, included functionality, usage limits, and eligibility requirements shall be described within the App or on the Company’s website at the time of purchase.</p>
              <p>The Company reserves the right to modify subscription offerings, pricing structures, included features, usage limits, and plan names at any time, subject to applicable law and any notice requirements imposed by the applicable marketplace.</p>
              <h3>5.3 Subscription Authorization</h3>
              <p>By purchasing a subscription, you authorize the applicable marketplace, payment processor, or billing provider to charge your selected payment method on a recurring basis until cancellation.</p>
              <p>You acknowledge and agree that:</p>
              <ul>
                <li>subscriptions automatically renew;</li>
                <li>charges may occur at the beginning of each billing cycle;</li>
                <li>recurring billing continues until cancelled;</li>
                <li>cancellation must occur before the applicable renewal date to prevent renewal charges; and</li>
                <li>the Company may rely upon information provided by the applicable marketplace concerning billing status and subscription status.</li>
              </ul>
              <h3>5.4 App Store Billing</h3>
              <p>Where required by the applicable platform, subscriptions and in-app purchases shall be purchased exclusively through:</p>
              <ul>
                <li>Apple App Store;</li>
                <li>Google Play Store; or</li>
                <li>another authorized marketplace designated by the Company.</li>
              </ul>
              <p>Billing, payment processing, subscription management, renewal processing, cancellation rights, refund eligibility, and payment disputes may be governed by the terms, conditions, and policies of the applicable marketplace.</p>
              <p>To the extent of any conflict between these Terms and the mandatory billing requirements of an applicable marketplace, the marketplace requirements shall prevail.</p>
              <h3>5.5 Free Trials and Promotional Offers</h3>
              <p>The Company may offer free trials, introductory pricing, promotional subscriptions, discounted plans, referral credits, or other promotional offers.</p>
              <p>Unless otherwise disclosed at the time of enrollment:</p>
              <ul>
                <li>free trials automatically convert to paid subscriptions at the conclusion of the trial period;</li>
                <li>recurring billing begins immediately following expiration of the trial period;</li>
                <li>promotional pricing expires at the conclusion of the promotional period; and</li>
                <li>standard pricing thereafter applies.</li>
              </ul>
              <p>The Company may modify, suspend, revoke, or discontinue promotional offers at any time, subject to applicable law.</p>
              <h3>5.6 Cancellation</h3>
              <p>Users may cancel subscriptions at any time through:</p>
              <ul>
                <li>the applicable marketplace account settings;</li>
                <li>subscription management settings within the App (where available); or</li>
                <li>any other method made available by the Company.</li>
              </ul>
              <p>Cancellation becomes effective at the end of the then-current billing period unless otherwise required by law.</p>
              <p>Except where required by law, cancellation does not entitle a user to a refund of charges already incurred.</p>
              <h3>5.7 Price Changes</h3>
              <p>The Company may change subscription pricing from time to time.</p>
              <p>Where required by applicable law or marketplace rules, advance notice of material pricing changes will be provided.</p>
              <p>Continued use of the subscription following the effective date of a pricing change constitutes acceptance of the revised pricing.</p>
              <p>If a user does not agree to revised pricing, the subscription must be cancelled before the revised pricing becomes effective.</p>
              <h3>5.8 Failed Payments</h3>
              <p>If a payment cannot be processed for any reason, including insufficient funds, expired payment credentials, declined transactions, chargebacks, payment disputes, marketplace restrictions, or billing failures, the Company may:</p>
              <ul>
                <li>suspend premium features;</li>
                <li>downgrade the account to a free tier;</li>
                <li>restrict access to subscription features;</li>
                <li>retry payment processing;</li>
                <li>terminate the subscription; or</li>
                <li>take any other action permitted by law.</li>
              </ul>
              <p>The Company shall not be liable for any loss of access resulting from a failed payment.</p>
              <h3>5.9 In-App Purchases</h3>
              <p>The Company may offer optional in-app purchases, including but not limited to:</p>
              <ul>
                <li>avatar customizations;</li>
                <li>mascot accessories;</li>
                <li>cosmetic enhancements;</li>
                <li>digital rewards;</li>
                <li>virtual items;</li>
                <li>Emergency Tokens;</li>
                <li>Gift Gems;</li>
                <li>premium content; and</li>
                <li>other digital features.</li>
              </ul>
              <p>Availability of in-app purchases may vary by platform, jurisdiction, age category, device type, and marketplace requirements.</p>
              <h3>5.10 Child-Initiated Purchases</h3>
              <p>The Company recognizes that Child Profiles are intended for minors.</p>
              <p>Accordingly, any purchase initiated from a Child Profile shall require authorization from the Parent Account holder through mechanisms established by the Company, the applicable marketplace, or both.</p>
              <p>Parents are solely responsible for:</p>
              <ul>
                <li>supervising purchases;</li>
                <li>configuring parental controls;</li>
                <li>protecting account credentials;</li>
                <li>controlling access to payment methods; and</li>
                <li>reviewing purchase activity.</li>
              </ul>
              <p>The Company is not responsible for unauthorized purchases resulting from compromised credentials, failure to use available parental controls, or unauthorized access to a Parent Account.</p>
              <h3>5.11 Virtual Items</h3>
              <p>The App may include virtual items, virtual currencies, digital rewards, Emergency Tokens, Gift Gems, badges, achievements, streaks, cosmetic upgrades, and other digital content (collectively, &quot;Virtual Items&quot;).</p>
              <p>Virtual Items:</p>
              <ul>
                <li>have no cash value;</li>
                <li>are not redeemable for money;</li>
                <li>are not transferable except where expressly permitted;</li>
                <li>do not constitute property;</li>
                <li>do not create any vested rights; and</li>
                <li>may be modified, suspended, removed, or discontinued at any time.</li>
              </ul>
              <p>Users acquire only a limited, revocable license to use Virtual Items within the App.</p>
              <h3>5.12 No Investment or Financial Product</h3>
              <p>Virtual Items, Coins, Gift Gems, Emergency Tokens, Ledger balances, rewards, allowances, and other digital features:</p>
              <ul>
                <li>are not securities;</li>
                <li>are not investments;</li>
                <li>are not financial products;</li>
                <li>are not deposit accounts;</li>
                <li>are not electronic money; and</li>
                <li>do not appreciate in value.</li>
              </ul>
              <p>The Company makes no representation concerning future value, utility, availability, or continued existence of any Virtual Item.</p>
              <h3>5.13 Refunds</h3>
              <p>Except where required by law, subscription fees and in-app purchases are non-refundable.</p>
              <p>Refund eligibility may depend upon:</p>
              <ul>
                <li>applicable consumer protection legislation;</li>
                <li>marketplace policies;</li>
                <li>payment provider policies; and</li>
                <li>the circumstances giving rise to the refund request.</li>
              </ul>
              <p>Where a purchase is made through Apple App Store, Google Play Store, or another marketplace, refund requests may be subject to that marketplace’s refund procedures.</p>
              <p>The Company reserves the right to grant, deny, or partially grant refund requests where permitted by law.</p>
              <h3>5.14 Taxes</h3>
              <p>Users are responsible for all applicable taxes, duties, levies, governmental charges, value-added taxes, sales taxes, goods and services taxes, harmonized sales taxes, withholding taxes, and similar charges associated with subscriptions or purchases.</p>
              <p>Applicable taxes may be collected by the Company, the marketplace, or a third-party billing provider as required by law.</p>
              <h3>5.15 Future Payment Providers</h3>
              <p>The Company may engage third-party payment processors, payment gateways, financial institutions, marketplace operators, digital wallet providers, and other service providers in connection with subscription billing or in-app purchases.</p>
              <p>Use of such services may require users to accept additional terms and conditions imposed by those providers.</p>
              <p>The Company is not responsible for the performance, availability, security, or actions of third-party payment providers.</p>
              <h3>5.16 Suspension, Modification, or Discontinuance</h3>
              <p>The Company reserves the right to modify, suspend, discontinue, restrict, or remove any subscription, paid feature, in-app purchase, Virtual Item, Emergency Token, Gift Gem, pricing plan, promotional program, or monetization feature at any time, subject to applicable law.</p>
              <p>To the maximum extent permitted by law, the Company shall not be liable for any loss arising from the modification, suspension, discontinuance, or removal of any paid feature or Virtual Item.</p>
              <p>6. Privacy, Data Collection, Child Privacy, and Information Security</p>
              <h3>6.1 Privacy Policy</h3>
              <p>Your use of the App is subject to the Company’s Privacy Policy, which is incorporated into these Terms by reference.</p>
              <p>The Privacy Policy explains how the Company collects, uses, stores, processes, transfers, protects, retains, discloses, and deletes information relating to users of the App.</p>
              <p>By accessing or using the App, you acknowledge that you have reviewed the Privacy Policy and consent to the practices described therein.</p>
              <p>If you do not agree with the Privacy Policy, you must not use the App.</p>
              <h3>6.2 Privacy-by-Design and Data Minimization</h3>
              <p>The Company is committed to privacy-by-design principles and seeks to collect only the information reasonably necessary to provide, operate, maintain, improve, secure, and support the App.</p>
              <p>Except as expressly disclosed in these Terms or the Privacy Policy, the App is not designed to:</p>
              <ul>
                <li>collect GPS location information;</li>
                <li>collect message content;</li>
                <li>collect emails or communications content;</li>
                <li>collect photographs or videos;</li>
                <li>collect personal files or documents;</li>
                <li>record keystrokes;</li>
                <li>capture passwords;</li>
                <li>record screen contents;</li>
                <li>collect browsing history; or</li>
                <li>access information unrelated to operation of the App.</li>
              </ul>
              <p>The Company reserves the right to modify data collection practices in future versions of the App, provided such modifications are disclosed through updated privacy notices and, where required by law, additional consent mechanisms.</p>
              <h3>6.3 Information We Collect</h3>
              <p>The Company may collect, generate, receive, process, or maintain information including:</p>
              <ul>
                <li>account information;</li>
                <li>Parent Account information;</li>
                <li>Child Profile information;</li>
                <li>device information;</li>
                <li>operating system information;</li>
                <li>application usage information;</li>
                <li>Focus Window information;</li>
                <li>Active Guard monitoring information;</li>
                <li>Active Boost activity information;</li>
                <li>Ledger information;</li>
                <li>subscription and billing information;</li>
                <li>customer support communications;</li>
                <li>analytics information;</li>
                <li>technical diagnostic information;</li>
                <li>security-related information; and</li>
                <li>information voluntarily provided by users.</li>
              </ul>
              <p>The categories of information collected may change as the App evolves.</p>
              <p>Additional categories of information may be collected where disclosed through updated notices, consent requests, or Privacy Policy updates.</p>
              <h3>6.4 Child Privacy Protections</h3>
              <p>The Company recognizes that information relating to children requires enhanced protection.</p>
              <p>Information associated with Child Profiles shall be processed solely for legitimate business purposes including:</p>
              <ul>
                <li>providing App functionality;</li>
                <li>facilitating parental supervision tools;</li>
                <li>generating family analytics;</li>
                <li>maintaining security;</li>
                <li>improving App performance;</li>
                <li>complying with legal obligations; and</li>
                <li>other purposes disclosed in the Privacy Policy.</li>
              </ul>
              <p>The Company does not knowingly sell personal information associated with Child Profiles.</p>
              <p>The Company does not knowingly use Child Profile information for behavioural advertising, interest-based advertising, or third-party marketing purposes.</p>
              <p>Where applicable, the Company intends to comply with:</p>
              <ul>
                <li>the Personal Information Protection and Electronic Documents Act (Canada);</li>
                <li>applicable provincial privacy legislation;</li>
                <li>the Children’s Online Privacy Protection Act (United States);</li>
                <li>applicable consumer protection legislation; and</li>
                <li>other privacy laws applicable to the Company’s operations.</li>
              </ul>
              <p>Nothing in these Terms constitutes a representation that any specific regulatory framework applies to every user or jurisdiction.</p>
              <h3>6.5 Parental Rights</h3>
              <p>Subject to applicable law and reasonable verification procedures, Parent Account holders may request:</p>
              <ul>
                <li>access to information associated with a Child Profile;</li>
                <li>correction of inaccurate information;</li>
                <li>export of information;</li>
                <li>deletion of information;</li>
                <li>withdrawal of consent; and</li>
                <li>restriction of certain processing activities.</li>
              </ul>
              <p>The Company may require reasonable proof of identity and parental authority before responding to such requests.</p>
              <p>The Company reserves the right to deny requests that are unlawful, technically infeasible, fraudulent, excessive, repetitive, abusive, or otherwise prohibited by law.</p>
              <h3>6.6 Analytics and Aggregated Information</h3>
              <p>The Company may generate aggregated, anonymized, de-identified, statistical, technical, and analytical information derived from use of the App.</p>
              <p>Such information may be used for:</p>
              <ul>
                <li>improving the App;</li>
                <li>developing new features;</li>
                <li>measuring performance;</li>
                <li>security monitoring;</li>
                <li>business analytics;</li>
                <li>research;</li>
                <li>benchmarking; and</li>
                <li>other lawful business purposes.</li>
              </ul>
              <p>Aggregated or de-identified information may continue to be used after account deletion provided it cannot reasonably identify an individual.</p>
              <h3>6.7 Third-Party Service Providers</h3>
              <p>The Company may engage third-party providers to assist with:</p>
              <ul>
                <li>hosting;</li>
                <li>cloud infrastructure;</li>
                <li>authentication;</li>
                <li>analytics;</li>
                <li>customer support;</li>
                <li>payment processing;</li>
                <li>subscription management;</li>
                <li>communications;</li>
                <li>security services; and</li>
                <li>other operational functions.</li>
              </ul>
              <p>Such providers may access information only to the extent reasonably necessary to perform services on behalf of the Company.</p>
              <p>The Company is not responsible for independent acts or omissions of third-party providers beyond its reasonable control.</p>
              <h3>6.8 Cross-Border Processing and Data Transfers</h3>
              <p>Information may be collected, stored, processed, transmitted, backed up, or accessed in jurisdictions outside a user’s province, territory, state, or country of residence.</p>
              <p>By using the App, users expressly consent to such transfers and processing.</p>
              <p>Users acknowledge that:</p>
              <ul>
                <li>foreign governments, courts, regulators, and law-enforcement authorities may obtain access to information under applicable foreign laws;</li>
                <li>privacy protections in foreign jurisdictions may differ from those available in Canada; and</li>
                <li>information may be transferred between multiple jurisdictions in connection with operation of the App.</li>
              </ul>
              <p>The Company will implement reasonable contractual, organizational, and technical safeguards designed to protect transferred information.</p>
              <h3>6.9 Data Residency</h3>
              <p>Unless expressly stated otherwise in the Privacy Policy, the Company does not guarantee that information will remain within Canada or any specific jurisdiction.</p>
              <p>Users should not assume Canadian data residency solely because the Company is incorporated or operates in Canada.</p>
              <h3>6.10 Information Security</h3>
              <p>The Company employs administrative, technical, contractual, organizational, and physical safeguards designed to protect information against unauthorized access, disclosure, alteration, misuse, loss, or destruction.</p>
              <p>However, no software application, network, internet transmission, cloud environment, or electronic storage system can be guaranteed to be completely secure.</p>
              <p>Accordingly, the Company does not guarantee the security, integrity, confidentiality, or availability of information transmitted to, from, or through the App.</p>
              <h3>6.11 Security Incidents</h3>
              <p>The Company reserves the right to investigate suspected security incidents, misuse, fraud, unauthorized access, or violations of these Terms.</p>
              <p>Where required by law, the Company will provide notification of certain security incidents or privacy breaches.</p>
              <p>The timing, content, and recipients of any notification shall be determined by the Company in accordance with applicable legal requirements.</p>
              <h3>6.12 Data Retention</h3>
              <p>Information will be retained only for as long as reasonably necessary to:</p>
              <ul>
                <li>provide the App;</li>
                <li>fulfill contractual obligations;</li>
                <li>comply with legal requirements;</li>
                <li>resolve disputes;</li>
                <li>enforce agreements;</li>
                <li>prevent fraud;</li>
                <li>maintain security;</li>
                <li>preserve backup integrity; and</li>
                <li>protect the Company’s legitimate interests.</li>
              </ul>
              <p>Retention periods may vary depending upon the type of information involved and applicable legal requirements.</p>
              <h3>6.13 Deletion Requests</h3>
              <p>Subject to applicable law, Parent Account holders may request deletion of their account and associated Child Profiles.</p>
              <p>Upon receipt of a verified deletion request, the Company will take reasonable steps to delete, anonymize, or de-identify applicable information within a commercially reasonable period.</p>
              <p>The Company may retain information where necessary for:</p>
              <ul>
                <li>legal compliance;</li>
                <li>dispute resolution;</li>
                <li>fraud prevention;</li>
                <li>security;</li>
                <li>backup systems;</li>
                <li>enforcement of agreements; or</li>
                <li>other legitimate business purposes permitted by law.</li>
              </ul>
              <h3>6.14 Government and Legal Requests</h3>
              <p>The Company may disclose information where required or permitted by law, including in response to:</p>
              <ul>
                <li>court orders;</li>
                <li>subpoenas;</li>
                <li>warrants;</li>
                <li>regulatory requests;</li>
                <li>law-enforcement requests; or</li>
                <li>other legal processes.</li>
              </ul>
              <p>The Company may also disclose information where reasonably necessary to protect:</p>
              <ul>
                <li>users;</li>
                <li>children;</li>
                <li>the public;</li>
                <li>the Company’s rights;</li>
                <li>the App’s security; or</li>
                <li>compliance with legal obligations.</li>
              </ul>
              <h3>6.15 Changes to Privacy Practices</h3>
              <p>The Company reserves the right to modify its information-handling practices from time to time.</p>
              <p>Material changes affecting user rights or expectations will be disclosed through updated privacy notices, revised Privacy Policies, in-App notices, email communications, or other appropriate means.</p>
              <p>Where required by law, additional consent will be obtained before implementing certain changes.</p>
              <p>Continued use of the App following implementation of revised privacy practices constitutes acceptance of those practices to the extent permitted by law.</p>
              <p>7. Parental Responsibilities and Acknowledgements</p>
              <h3>7.1 Parent Responsibility</h3>
              <p>The App is intended to assist parents and legal guardians in managing household goals, encouraging healthy device habits, administering rewards programs, and monitoring designated device activity.</p>
              <p>The Parent Account holder remains solely responsible for:</p>
              <ul>
                <li>supervising the child;</li>
                <li>making parenting decisions;</li>
                <li>determining appropriate screen-time limits;</li>
                <li>establishing household rules;</li>
                <li>determining allowance and reward amounts;</li>
                <li>evaluating behavioural outcomes;</li>
                <li>deciding whether rewards should be granted or withheld; and</li>
                <li>ensuring that use of the App is appropriate for the child.</li>
              </ul>
              <p>Nothing in the App transfers any parenting, supervisory, educational, disciplinary, caregiving, custodial, guardianship, or decision-making responsibility from the parent to the Company.</p>
              <h3>7.2 Configuration Responsibilities</h3>
              <p>The Parent Account holder is solely responsible for:</p>
              <ul>
                <li>creating and maintaining Child Profiles;</li>
                <li>selecting Monitored Apps;</li>
                <li>configuring Focus Windows;</li>
                <li>configuring Exclusion Windows;</li>
                <li>configuring Active Boost settings;</li>
                <li>configuring earning rates;</li>
                <li>configuring reward structures;</li>
                <li>linking devices;</li>
                <li>maintaining account credentials; and</li>
                <li>reviewing App settings on an ongoing basis.</li>
              </ul>
              <p>The Company does not review, approve, verify, recommend, or monitor the appropriateness of user-selected settings.</p>
              <h3>7.3 Accuracy of Information</h3>
              <p>The Parent Account holder is responsible for ensuring that all information provided to the Company is accurate, current, complete, and not misleading.</p>
              <p>The Parent Account holder shall promptly update account information whenever relevant information changes, including:</p>
              <ul>
                <li>changes to contact information;</li>
                <li>changes to parental authority;</li>
                <li>changes to guardianship arrangements;</li>
                <li>changes to custody arrangements;</li>
                <li>changes to device ownership;</li>
                <li>changes to linked devices; and</li>
                <li>changes affecting the child’s eligibility to use the App.</li>
              </ul>
              <h3>7.4 Device Management Responsibilities</h3>
              <p>The Parent Account holder is responsible for:</p>
              <ul>
                <li>ensuring that Linked Devices are properly configured;</li>
                <li>maintaining required permissions;</li>
                <li>reviewing operating-system settings;</li>
                <li>reviewing software updates;</li>
                <li>monitoring device compatibility;</li>
                <li>maintaining internet connectivity where required; and</li>
                <li>ensuring that the child uses the intended Linked Devices.</li>
              </ul>
              <p>The Company is not responsible for monitoring failures resulting from device settings, permission changes, hardware limitations, software conflicts, operating-system restrictions, network failures, or third-party platform changes.</p>
              <h3>7.5 Monitoring Limitations</h3>
              <p>The Parent Account holder acknowledges that Active Guard is a supplemental monitoring tool only.</p>
              <p>The Company does not guarantee that Active Guard will:</p>
              <ul>
                <li>detect every instance of device usage;</li>
                <li>detect every instance of Monitored App usage;</li>
                <li>accurately record all activity;</li>
                <li>operate continuously without interruption;</li>
                <li>remain compatible with all devices;</li>
                <li>remain compatible with future operating-system versions; or</li>
                <li>function identically across all platforms.</li>
              </ul>
              <p>Parents remain responsible for independently supervising and monitoring their children.</p>
              <h3>7.6 Child Safety</h3>
              <p>The Parent Account holder acknowledges that the App is not a child-safety service.</p>
              <p>The App is not designed or intended to:</p>
              <ul>
                <li>prevent harm;</li>
                <li>prevent bullying;</li>
                <li>prevent online exploitation;</li>
                <li>prevent inappropriate content exposure;</li>
                <li>prevent addiction;</li>
                <li>prevent self-harm;</li>
                <li>prevent criminal activity;</li>
                <li>monitor emergencies;</li>
                <li>detect dangerous situations; or</li>
                <li>replace parental supervision.</li>
              </ul>
              <p>The Company makes no representation that use of the App will improve child safety or eliminate risks associated with technology use.</p>
              <h3>7.7 Educational and Behavioural Outcomes</h3>
              <p>The Parent Account holder acknowledges that the Company does not guarantee that use of the App will:</p>
              <ul>
                <li>reduce screen time;</li>
                <li>improve grades;</li>
                <li>improve concentration;</li>
                <li>improve productivity;</li>
                <li>improve behaviour;</li>
                <li>improve discipline;</li>
                <li>improve family relationships;</li>
                <li>improve physical activity;</li>
                <li>improve sleep habits; or</li>
                <li>achieve any particular parenting objective.</li>
              </ul>
              <p>Results may vary significantly between users.</p>
              <p>The Company provides tools only and does not guarantee outcomes.</p>
              <h3>7.8 Rewards and Allowances</h3>
              <p>The Parent Account holder is solely responsible for:</p>
              <ul>
                <li>establishing earning criteria;</li>
                <li>determining whether earnings should be paid;</li>
                <li>determining the amount of any payment;</li>
                <li>determining the timing of payment;</li>
                <li>resolving disputes regarding rewards; and</li>
                <li>ensuring compliance with any applicable legal obligations.</li>
              </ul>
              <p>The Company is not a party to any arrangement between a parent and child relating to rewards, incentives, allowances, gifts, or payments.</p>
              <h3>7.9 Legal Compliance</h3>
              <p>The Parent Account holder agrees to use the App in compliance with all applicable laws, including laws relating to:</p>
              <ul>
                <li>privacy;</li>
                <li>child protection;</li>
                <li>guardianship;</li>
                <li>family law;</li>
                <li>electronic communications;</li>
                <li>consumer protection;</li>
                <li>data protection;</li>
                <li>surveillance; and</li>
                <li>technology usage.</li>
              </ul>
              <p>The Parent Account holder is solely responsible for obtaining any consent, authorization, approval, or permission required by law for use of the App.</p>
              <h3>7.10 Shared Parenting and Guardianship Arrangements</h3>
              <p>Where more than one parent, guardian, or legal decision-maker possesses authority concerning a child, the Parent Account holder is responsible for ensuring that use of the App complies with all applicable court orders, parenting orders, separation agreements, custody arrangements, guardianship arrangements, and legal obligations.</p>
              <p>The Company assumes no responsibility for disputes between parents, guardians, family members, or other individuals regarding use of the App.</p>
              <h3>7.11 Security Responsibilities</h3>
              <p>The Parent Account holder is responsible for:</p>
              <ul>
                <li>safeguarding login credentials;</li>
                <li>protecting devices used to access the App;</li>
                <li>maintaining appropriate security settings;</li>
                <li>reviewing account activity;</li>
                <li>promptly reporting suspected unauthorized access; and</li>
                <li>implementing appropriate parental controls available through device manufacturers and app marketplaces.</li>
              </ul>
              <p>The Company shall not be responsible for losses arising from unauthorized access resulting from compromised credentials or inadequate security practices.</p>
              <h3>7.12 Acknowledgement of Responsibility</h3>
              <p>By creating a Parent Account and using the App, you acknowledge and agree that:</p>
              <ul>
                <li>(a) the App is a supplemental family-management tool only;</li>
                <li>(b) parenting decisions remain your sole responsibility;</li>
                <li>(c) you remain responsible for supervising the child;</li>
                <li>(d) you remain responsible for all Child Profiles associated with your account; and</li>
                <li>(e) you assume responsibility for determining whether use of the App is appropriate for your family’s circumstances.</li>
              </ul>
              <p>8. Acceptable Use and ProhibitesProhibited Conduct</p>
              <h3>8.1 General Obligation</h3>
              <p>You agree to access and use the App only for lawful purposes and in accordance with these Terms.</p>
              <p>You shall not use the App in any manner that:</p>
              <ul>
                <li>violates applicable law;</li>
                <li>infringes the rights of any person;</li>
                <li>interferes with the operation of the App;</li>
                <li>compromises the security of the App;</li>
                <li>circumvents App functionality;</li>
                <li>violates the privacy of any individual; or</li>
                <li>otherwise exceeds the scope of authorization granted under these Terms.</li>
              </ul>
              <h3>8.2 Authorized Family Use Only</h3>
              <p>The App is intended solely for family-management, parental-supervision, reward-tracking, and related household purposes.</p>
              <p>You may use the App only in connection with:</p>
              <ul>
                <li>your own Parent Account;</li>
                <li>Child Profiles under your supervision; and</li>
                <li>Linked Devices that you are authorized to manage.</li>
              </ul>
              <p>The App may not be used as:</p>
              <ul>
                <li>employee-monitoring software;</li>
                <li>workplace surveillance software;</li>
                <li>covert tracking software;</li>
                <li>spyware;</li>
                <li>stalking software;</li>
                <li>investigative software;</li>
                <li>law-enforcement software; or</li>
                <li>any other unauthorized monitoring tool.</li>
              </ul>
              <h3>8.3 No Unauthorized Monitoring</h3>
              <p>You shall not install, configure, or use the App:</p>
              <ul>
                <li>on the device of any adult without their knowledge and authorization;</li>
                <li>on the device of a spouse, former spouse, partner, former partner, roommate, employee, contractor, student, tenant, or other individual without lawful authority;</li>
                <li>in violation of privacy legislation;</li>
                <li>in violation of employment legislation;</li>
                <li>in violation of surveillance laws;</li>
                <li>in violation of court orders;</li>
                <li>in violation of family-law obligations; or</li>
                <li>in any manner that could reasonably be considered covert monitoring.</li>
              </ul>
              <p>You are solely responsible for ensuring that all required consents, permissions, and authorizations have been obtained.</p>
              <h3>8.4 No Circumvention of App Functionality</h3>
              <p>You shall not attempt to:</p>
              <ul>
                <li>circumvent Active Guard;</li>
                <li>disable monitoring functionality;</li>
                <li>manipulate Focus Window results;</li>
                <li>interfere with earning calculations;</li>
                <li>interfere with Ledger calculations;</li>
                <li>bypass parental controls;</li>
                <li>exploit technical vulnerabilities; or</li>
                <li>otherwise manipulate the operation of the App.</li>
              </ul>
              <h3>8.5 No Fraudulent Activity</h3>
              <p>You shall not:</p>
              <ul>
                <li>create false activity records;</li>
                <li>generate fraudulent rewards;</li>
                <li>manipulate Active Boost calculations;</li>
                <li>create fraudulent accounts;</li>
                <li>impersonate another person;</li>
                <li>misrepresent your identity;</li>
                <li>provide false information;</li>
                <li>misuse referral programs;</li>
                <li>abuse promotional programs; or</li>
                <li>otherwise engage in deceptive activity.</li>
              </ul>
              <p>The Company may investigate suspected fraud and take any action reasonably necessary to protect the App and its users.</p>
              <h3>8.6 No Reverse Engineering</h3>
              <p>Except where prohibited by applicable law, you shall not:</p>
              <ul>
                <li>reverse engineer;</li>
                <li>decompile;</li>
                <li>disassemble;</li>
                <li>decode;</li>
                <li>modify;</li>
                <li>create derivative works from;</li>
                <li>attempt to discover source code for; or</li>
                <li>otherwise attempt to access the underlying technology of the App.</li>
              </ul>
              <p>You shall not assist any third party in engaging in such activities.</p>
              <h3>8.7 No Security Violations</h3>
              <p>You shall not:</p>
              <ul>
                <li>attempt unauthorized access to the App;</li>
                <li>attempt unauthorized access to user accounts;</li>
                <li>interfere with security features;</li>
                <li>introduce malware;</li>
                <li>introduce viruses;</li>
                <li>introduce ransomware;</li>
                <li>introduce malicious code;</li>
                <li>conduct penetration testing without authorization;</li>
                <li>engage in denial-of-service attacks; or</li>
                <li>otherwise compromise App security.</li>
              </ul>
              <h3>8.8 No Interference with Service Operations</h3>
              <p>You shall not:</p>
              <ul>
                <li>overload the App;</li>
                <li>interfere with infrastructure;</li>
                <li>disrupt service availability;</li>
                <li>interfere with communications;</li>
                <li>automate access in an unauthorized manner;</li>
                <li>scrape data;</li>
                <li>harvest information;</li>
                <li>use bots or scripts in violation of these Terms; or</li>
                <li>otherwise impair the operation of the App.</li>
              </ul>
              <h3>8.9 Compliance with Laws</h3>
              <p>You agree to comply with all applicable laws relating to:</p>
              <ul>
                <li>privacy;</li>
                <li>data protection;</li>
                <li>child protection;</li>
                <li>family law;</li>
                <li>guardianship;</li>
                <li>consumer protection;</li>
                <li>electronic communications;</li>
                <li>cybersecurity;</li>
                <li>intellectual property;</li>
                <li>sanctions and export controls; and</li>
                <li>technology use.</li>
              </ul>
              <p>The Company makes no representation that use of the App is lawful in every jurisdiction.</p>
              <p>You are responsible for determining whether use of the App is lawful in your jurisdiction.</p>
              <h3>8.10 User Content and Communications</h3>
              <p>To the extent the App permits communications, support requests, profile information, feedback, reviews, or other user-submitted content, you shall not submit content that:</p>
              <ul>
                <li>is unlawful;</li>
                <li>is defamatory;</li>
                <li>is fraudulent;</li>
                <li>is abusive;</li>
                <li>is threatening;</li>
                <li>is harassing;</li>
                <li>is discriminatory;</li>
                <li>infringes intellectual property rights;</li>
                <li>violates privacy rights; or</li>
                <li>otherwise violates applicable law.</li>
              </ul>
              <p>The Company may remove content at its discretion.</p>
              <h3>8.11 No Commercial Exploitation</h3>
              <p>Unless expressly authorized in writing by the Company, you shall not:</p>
              <ul>
                <li>resell the App;</li>
                <li>sublicense the App;</li>
                <li>commercially exploit the App;</li>
                <li>provide the App as a service bureau;</li>
                <li>use the App for competitive analysis;</li>
                <li>use the App to develop competing products; or</li>
                <li>otherwise exploit the App for commercial purposes.</li>
              </ul>
              <h3>8.12 Reporting Violations</h3>
              <p>Users may report suspected misuse, unauthorized monitoring, privacy concerns, fraud, security issues, or violations of these Terms by contacting support@chachingapp.ca.</p>
              <p>The Company may investigate reported violations and cooperate with law-enforcement authorities where appropriate.</p>
              <h3>8.13 Enforcement</h3>
              <p>The Company reserves the right to:</p>
              <ul>
                <li>investigate suspected violations;</li>
                <li>suspend accounts;</li>
                <li>restrict functionality;</li>
                <li>remove content;</li>
                <li>terminate accounts;</li>
                <li>report unlawful conduct to authorities; and</li>
                <li>take any other action reasonably necessary to protect the App, its users, children, third parties, or the Company’s legal rights.</li>
              </ul>
              <p>The Company is not obligated to monitor user conduct but reserves the right to do so where reasonably necessary.</p>
              <h3>8.14 No Waiver</h3>
              <p>Failure by the Company to enforce any provision of this Section shall not constitute a waiver of the Company’s right to enforce such provision at a later time.</p>
              <h3>8.15 Survival</h3>
              <p>The provisions of this Section shall survive termination of these Terms to the extent necessary to protect the Company, its users, and its legal rights.</p>
              <p>9. Third-Party Services, Platforms and Integrations</p>
              <h3>9.1 Reliance on Third-Party Providers</h3>
              <p>The App relies upon and may integrate with various third-party providers, technologies, services, platforms, operating systems, marketplaces, and infrastructure providers (collectively, &quot;Third-Party Providers&quot;).</p>
              <p>Third-Party Providers may include:</p>
              <ul>
                <li>Apple Inc.;</li>
                <li>Google LLC;</li>
                <li>device manufacturers;</li>
                <li>mobile network operators;</li>
                <li>internet service providers;</li>
                <li>cloud-hosting providers;</li>
                <li>authentication providers;</li>
                <li>analytics providers;</li>
                <li>customer-support providers;</li>
                <li>payment processors;</li>
                <li>subscription-management providers;</li>
                <li>communications providers; and</li>
                <li>other service providers utilized by the Company.</li>
              </ul>
              <p>The Company does not own or control Third-Party Providers and cannot guarantee their performance, availability, security, reliability, compatibility, or continued operation.</p>
              <h3>9.2 Platform Dependencies</h3>
              <p>Certain functionality of the App depends upon services, permissions, APIs, software development kits (SDKs), operating-system functionality, and technical capabilities made available by Third-Party Providers.</p>
              <p>The Company may be unable to provide certain features if:</p>
              <ul>
                <li>required permissions are unavailable;</li>
                <li>operating-system restrictions are imposed;</li>
                <li>APIs are modified;</li>
                <li>APIs are discontinued;</li>
                <li>platform policies change;</li>
                <li>marketplace requirements change;</li>
                <li>technical access is restricted; or</li>
                <li>Third-Party Providers otherwise alter or discontinue functionality.</li>
              </ul>
              <p>The Company shall not be responsible for limitations, interruptions, degradation, or loss of functionality resulting from actions taken by Third-Party Providers.</p>
              <h3>9.3 App Marketplaces</h3>
              <p>The App may be distributed through:</p>
              <ul>
                <li>Apple App Store;</li>
                <li>Google Play Store; and</li>
                <li>other authorized marketplaces.</li>
              </ul>
              <p>Your use of such marketplaces is governed by the terms, conditions, policies, privacy practices, refund policies, subscription policies, and other requirements established by the applicable marketplace.</p>
              <p>The Company is not responsible for:</p>
              <ul>
                <li>marketplace availability;</li>
                <li>marketplace outages;</li>
                <li>marketplace restrictions;</li>
                <li>marketplace account suspensions;</li>
                <li>marketplace payment processing;</li>
                <li>marketplace approval decisions; or</li>
                <li>marketplace policy changes.</li>
              </ul>
              <h3>9.4 Authentication Services</h3>
              <p>The App may permit account creation and login through third-party authentication services, including Google OAuth and similar authentication providers.</p>
              <p>Use of such authentication services is governed by the terms and privacy policies of the applicable provider.</p>
              <p>The Company is not responsible for:</p>
              <ul>
                <li>authentication failures;</li>
                <li>account lockouts;</li>
                <li>credential-management issues;</li>
                <li>service interruptions;</li>
                <li>identity-verification decisions; or</li>
                <li>security incidents involving third-party authentication providers.</li>
              </ul>
              <h3>9.5 Hosting and Cloud Infrastructure</h3>
              <p>The Company may utilize third-party cloud-hosting, storage, networking, backup, and infrastructure providers.</p>
              <p>The Company does not guarantee uninterrupted access to the App and shall not be liable for interruptions arising from:</p>
              <ul>
                <li>cloud-service outages;</li>
                <li>hosting-provider failures;</li>
                <li>internet disruptions;</li>
                <li>telecommunications failures;</li>
                <li>infrastructure maintenance;</li>
                <li>distributed denial-of-service attacks;</li>
                <li>cybersecurity incidents; or</li>
                <li>other events beyond the Company’s reasonable control.</li>
              </ul>
              <h3>9.6 Analytics and Monitoring Providers</h3>
              <p>The Company may use third-party analytics, performance-monitoring, crash-reporting, diagnostics, logging, and business-intelligence providers to assist with operation and improvement of the App.</p>
              <p>Such providers may process information in accordance with their own privacy practices and contractual arrangements with the Company.</p>
              <p>The Company is not responsible for the independent acts or omissions of such providers.</p>
              <h3>9.7 Future Payment Providers</h3>
              <p>If the Company introduces subscription billing, in-app purchases, or integrated payment functionality, payment processing may be provided by third-party payment processors, financial institutions, digital wallet providers, marketplace billing systems, or other service providers.</p>
              <p>The Company does not control and shall not be responsible for:</p>
              <ul>
                <li>payment-processing delays;</li>
                <li>payment failures;</li>
                <li>payment disputes;</li>
                <li>chargebacks;</li>
                <li>fraud investigations;</li>
                <li>account restrictions;</li>
                <li>identity-verification requirements; or</li>
                <li>actions taken by payment providers.</li>
              </ul>
              <p>Use of such services may require acceptance of additional terms and conditions.</p>
              <h3>9.8 Third-Party Links and Applications</h3>
              <p>The App may contain links to, launch, interact with, connect to, or otherwise facilitate access to third-party websites, applications, products, services, content, or platforms.</p>
              <p>Such third-party services are provided solely for convenience.</p>
              <p>The Company does not:</p>
              <ul>
                <li>endorse third-party services;</li>
                <li>guarantee third-party services;</li>
                <li>control third-party services;</li>
                <li>review third-party services; or</li>
                <li>assume responsibility for third-party services.</li>
              </ul>
              <p>Users access third-party services entirely at their own risk.</p>
              <h3>9.9 Open-Source Software</h3>
              <p>Certain components of the App may include open-source software governed by separate license terms.</p>
              <p>To the extent required by applicable open-source licenses, such licenses shall govern use of the applicable software components.</p>
              <p>Nothing in these Terms limits rights granted under applicable open-source licenses.</p>
              <h3>9.10 Changes to Third-Party Services</h3>
              <p>Third-Party Providers may change, suspend, discontinue, restrict, replace, or modify their services at any time without notice to the Company.</p>
              <p>The Company reserves the right to:</p>
              <ul>
                <li>modify App functionality;</li>
                <li>suspend features;</li>
                <li>discontinue integrations;</li>
                <li>replace providers; or</li>
                <li>remove functionality</li>
              </ul>
              <p>where reasonably necessary due to actions taken by Third-Party Providers.</p>
              <h3>9.11 No Responsibility for Third-Party Conduct</h3>
              <p>To the maximum extent permitted by law, the Company shall not be responsible for any loss, damage, liability, claim, expense, interruption, delay, or harm arising from:</p>
              <ul>
                <li>acts or omissions of Third-Party Providers;</li>
                <li>service outages;</li>
                <li>policy changes;</li>
                <li>operating-system changes;</li>
                <li>API modifications;</li>
                <li>account suspensions;</li>
                <li>data processing activities;</li>
                <li>payment-processing activities;</li>
                <li>marketplace actions; or</li>
                <li>other conduct attributable to Third-Party Providers.</li>
              </ul>
              <h3>9.12 Reservation of Rights</h3>
              <p>The Company reserves the right to add, remove, modify, replace, or discontinue any Third-Party Provider, integration, service, API, authentication provider, hosting provider, payment provider, marketplace integration, or platform dependency at any time without liability, subject to applicable law.</p>
              <p>10. Analytics, Reporting and Family Insights</p>
              <h3>10.1 Purpose of Analytics Features</h3>
              <p>The App may provide analytics, reports, dashboards, insights, summaries, notifications, trends, metrics, and other informational tools (collectively, the &quot;Analytics Features&quot;) intended to assist Parent Account holders in understanding information generated through use of the App.</p>
              <p>Analytics Features are provided solely for informational and convenience purposes.</p>
              <p>Analytics Features are intended to support parental decision-making and are not intended to replace parental judgment, supervision, or independent evaluation.</p>
              <h3>10.2 Family Analytics Dashboard</h3>
              <p>The App may provide a Family Analytics Dashboard that presents information relating to one or more Child Profiles.</p>
              <p>Information presented may include:</p>
              <ul>
                <li>Focus Window completion rates;</li>
                <li>focus streaks;</li>
                <li>Active Guard activity metrics;</li>
                <li>Monitored App usage metrics;</li>
                <li>Active Boost activity metrics;</li>
                <li>reward and allowance information;</li>
                <li>Ledger information;</li>
                <li>historical trends;</li>
                <li>progress summaries;</li>
                <li>achievement indicators;</li>
                <li>engagement metrics; and</li>
                <li>other information generated through operation of the App.</li>
              </ul>
              <p>The categories of information displayed may change from time to time as the App evolves.</p>
              <h3>10.3 Informational Nature of Analytics</h3>
              <p>All Analytics Features are informational estimates generated through automated processes.</p>
              <p>Analytics Features may be affected by:</p>
              <ul>
                <li>device limitations;</li>
                <li>operating-system restrictions;</li>
                <li>permission settings;</li>
                <li>synchronization delays;</li>
                <li>network interruptions;</li>
                <li>software defects;</li>
                <li>inaccurate device information;</li>
                <li>user configuration choices;</li>
                <li>third-party platform limitations; and</li>
                <li>other technical factors beyond the Company’s control.</li>
              </ul>
              <p>The Company does not guarantee the accuracy, completeness, reliability, timeliness, or suitability of any analytics, report, metric, trend, calculation, dashboard, insight, notification, recommendation, or summary generated by the App.</p>
              <h3>10.4 No Professional Advice</h3>
              <p>Analytics Features do not constitute:</p>
              <ul>
                <li>parenting advice;</li>
                <li>educational advice;</li>
                <li>behavioural advice;</li>
                <li>medical advice;</li>
                <li>health advice;</li>
                <li>psychological advice;</li>
                <li>legal advice;</li>
                <li>financial advice;</li>
                <li>investment advice; or</li>
                <li>professional advice of any kind.</li>
              </ul>
              <p>Users remain solely responsible for making decisions relating to children, rewards, allowances, behaviour, education, health, safety, and family management.</p>
              <h3>10.5 No Guaranteed Outcomes</h3>
              <p>The Company does not represent or warrant that information displayed through Analytics Features will:</p>
              <ul>
                <li>reduce screen time;</li>
                <li>improve academic performance;</li>
                <li>improve concentration;</li>
                <li>improve behaviour;</li>
                <li>improve family relationships;</li>
                <li>improve physical activity;</li>
                <li>improve sleep habits;</li>
                <li>increase productivity; or</li>
                <li>achieve any specific parenting objective.</li>
              </ul>
              <p>Analytics Features are tools only and should not be interpreted as guarantees of future outcomes.</p>
              <h3>10.6 User Responsibility</h3>
              <p>Parent Account holders remain solely responsible for:</p>
              <ul>
                <li>reviewing analytics information;</li>
                <li>evaluating the accuracy of analytics information;</li>
                <li>determining whether to rely upon analytics information;</li>
                <li>making parenting decisions; and</li>
                <li>verifying information before acting upon it.</li>
              </ul>
              <p>The Company shall not be responsible for decisions made in reliance upon Analytics Features.</p>
              <h3>10.7 Historical Data</h3>
              <p>The Company may store and display historical information relating to Child Profiles, Focus Windows, rewards, activity metrics, and other App usage information.</p>
              <p>Historical information may be modified, corrected, updated, archived, anonymized, aggregated, restricted, or deleted at any time in accordance with these Terms and the Privacy Policy.</p>
              <p>The Company does not guarantee the perpetual availability of historical records.</p>
              <h3>10.8 Future Analytics Features</h3>
              <p>The Company may introduce new analytics, reports, dashboards, artificial-intelligence tools, recommendations, insights, scoring systems, predictive tools, benchmarking features, notifications, or reporting functionality in future versions of the App.</p>
              <p>Such features may be subject to additional terms, disclosures, permissions, privacy notices, or consent requirements.</p>
              <p>The Company reserves the right to modify, suspend, limit, replace, or discontinue any Analytics Feature at any time.</p>
              <h3>10.9 Ownership of Analytics</h3>
              <p>All Analytics Features, algorithms, reporting methodologies, scoring methodologies, visualizations, dashboards, summaries, calculations, and related intellectual property remain the exclusive property of the Company or its licensors.</p>
              <p>Nothing in these Terms transfers ownership of any Analytics Feature to a user.</p>
              <h3>10.10 Aggregated and De-Identified Information</h3>
              <p>The Company may generate aggregated, anonymized, de-identified, or statistical information derived from App usage and Analytics Features.</p>
              <p>Such information may be used for:</p>
              <ul>
                <li>improving the App;</li>
                <li>developing new features;</li>
                <li>measuring performance;</li>
                <li>research;</li>
                <li>business planning;</li>
                <li>security monitoring;</li>
                <li>benchmarking; and</li>
                <li>other lawful business purposes.</li>
              </ul>
              <p>Aggregated and de-identified information may continue to be used following account deletion provided that it does not reasonably identify an individual.</p>
              <h3>10.11 Availability of Analytics Features</h3>
              <p>The availability of Analytics Features may depend upon:</p>
              <ul>
                <li>subscription level;</li>
                <li>platform capabilities;</li>
                <li>device compatibility;</li>
                <li>operating-system functionality;</li>
                <li>permissions granted by the user;</li>
                <li>third-party services; and</li>
                <li>technical limitations.</li>
              </ul>
              <p>The Company does not guarantee that all Analytics Features will be available on all devices, in all jurisdictions, or at all times.</p>
              <h3>10.12 Limitation of Reliance</h3>
              <p>To the maximum extent permitted by law, users acknowledge that Analytics Features are informational tools only and agree that the Company shall not be liable for any loss, damage, claim, expense, cost, or liability arising from:</p>
              <ul>
                <li>reliance upon analytics information;</li>
                <li>inaccuracies in analytics information;</li>
                <li>incomplete analytics information;</li>
                <li>unavailable analytics information; or</li>
                <li>decisions made based upon analytics information.</li>
              </ul>
              <p>11. Intellectual Property Rights</p>
              <h3>11.1 Ownership of the App</h3>
              <p>The App and all rights, title, and interests therein are and shall remain the exclusive property of 2422019 Ontario Inc. (o/a BuckTime!) and its licensors.</p>
              <p>The App includes, without limitation:</p>
              <ul>
                <li>software;</li>
                <li>source code;</li>
                <li>object code;</li>
                <li>algorithms;</li>
                <li>databases;</li>
                <li>interfaces;</li>
                <li>dashboards;</li>
                <li>analytics;</li>
                <li>reports;</li>
                <li>visualizations;</li>
                <li>designs;</li>
                <li>user interfaces;</li>
                <li>text;</li>
                <li>graphics;</li>
                <li>images;</li>
                <li>artwork;</li>
                <li>animations;</li>
                <li>audio;</li>
                <li>video;</li>
                <li>trademarks;</li>
                <li>logos;</li>
                <li>trade names;</li>
                <li>service marks;</li>
                <li>documentation;</li>
                <li>virtual items;</li>
                <li>rewards systems;</li>
                <li>scoring methodologies;</li>
                <li>business processes;</li>
                <li>proprietary technology; and</li>
                <li>all related intellectual property rights.</li>
              </ul>
              <p>Nothing in these Terms transfers ownership of any intellectual property rights to any user.</p>
              <h3>11.2 Limited License to Use the App</h3>
              <p>Subject to compliance with these Terms, the Company grants users a limited, personal, non-exclusive, non-transferable, non-sublicensable, revocable license to access and use the App solely for lawful personal family use.</p>
              <p>This license is granted solely for the purpose of using the App in accordance with its intended functionality.</p>
              <p>All rights not expressly granted are reserved by the Company.</p>
              <h3>11.3 Restrictions on Use</h3>
              <p>Except as expressly permitted by applicable law or these Terms, users shall not:</p>
              <ul>
                <li>copy the App;</li>
                <li>reproduce the App;</li>
                <li>distribute the App;</li>
                <li>publish the App;</li>
                <li>modify the App;</li>
                <li>create derivative works from the App;</li>
                <li>reverse engineer the App;</li>
                <li>decompile the App;</li>
                <li>disassemble the App;</li>
                <li>attempt to discover source code;</li>
                <li>remove proprietary notices;</li>
                <li>circumvent security features;</li>
                <li>interfere with intellectual property rights;</li>
                <li>scrape App data;</li>
                <li>harvest information from the App;</li>
                <li>use the App to develop competing products; or</li>
                <li>otherwise exploit the App beyond the scope of the license granted herein.</li>
              </ul>
              <h3>11.4 Trademarks</h3>
              <p>The names BuckTime!, Active Guard, Active Boost, Family Analytics Dashboard, and all associated logos, slogans, graphics, trade dress, and branding elements are trademarks, service marks, trade names, or proprietary branding of the Company or its licensors.</p>
              <p>Users may not use any trademark, logo, branding element, domain name, social-media identifier, or other source identifier associated with the Company without prior written consent.</p>
              <h3>11.5 Family Analytics and Proprietary Methodologies</h3>
              <p>The Company retains exclusive ownership of all:</p>
              <ul>
                <li>analytics methodologies;</li>
                <li>scoring systems;</li>
                <li>reward systems;</li>
                <li>monitoring methodologies;</li>
                <li>earning calculations;</li>
                <li>streak calculations;</li>
                <li>reporting methodologies;</li>
                <li>predictive models;</li>
                <li>recommendation engines;</li>
                <li>algorithms;</li>
                <li>machine-learning systems; and</li>
                <li>other proprietary methodologies used in connection with the App.</li>
              </ul>
              <p>No rights are granted to users with respect to such methodologies other than the limited right to receive their output through authorized use of the App.</p>
              <h3>11.6 Virtual Items</h3>
              <p>All Virtual Items made available through the App, including:</p>
              <ul>
                <li>Emergency Tokens;</li>
                <li>Gift Gems;</li>
                <li>badges;</li>
                <li>achievements;</li>
                <li>streaks;</li>
                <li>avatars;</li>
                <li>mascot customizations;</li>
                <li>cosmetic upgrades;</li>
                <li>digital rewards; and</li>
                <li>other virtual content</li>
              </ul>
              <p>remain the exclusive property of the Company.</p>
              <p>Users acquire only a limited, revocable license to use Virtual Items within the App.</p>
              <p>Virtual Items:</p>
              <ul>
                <li>have no ownership value;</li>
                <li>are not transferable except as expressly permitted;</li>
                <li>are not redeemable for cash;</li>
                <li>are not personal property; and</li>
                <li>may be modified or discontinued at any time.</li>
              </ul>
              <h3>11.7 User Feedback</h3>
              <p>If a user provides:</p>
              <ul>
                <li>suggestions;</li>
                <li>comments;</li>
                <li>ideas;</li>
                <li>recommendations;</li>
                <li>enhancement requests;</li>
                <li>bug reports;</li>
                <li>feature requests; or</li>
                <li>other feedback</li>
              </ul>
              <p>relating to the App (&quot;Feedback&quot;),</p>
              <p>the user grants the Company a perpetual, irrevocable, worldwide, royalty-free, transferable, sublicensable right to use, modify, reproduce, commercialize, incorporate, distribute, publish, and otherwise exploit such Feedback for any purpose without compensation or attribution.</p>
              <p>The Company shall have no obligation to implement any Feedback.</p>
              <h3>11.8 User Content</h3>
              <p>To the extent users submit profile information, support communications, feedback, messages, reviews, or other content through the App (&quot;User Content&quot;), the user retains ownership of such User Content.</p>
              <p>However, the user grants the Company a worldwide, non-exclusive, royalty-free license to host, store, process, reproduce, modify, display, transmit, and otherwise use User Content to:</p>
              <ul>
                <li>operate the App;</li>
                <li>provide services;</li>
                <li>respond to support requests;</li>
                <li>improve functionality;</li>
                <li>maintain security;</li>
                <li>comply with legal obligations; and</li>
                <li>enforce these Terms.</li>
              </ul>
              <h3>11.9 Aggregated and De-Identified Information</h3>
              <p>The Company shall own all rights in aggregated, anonymized, statistical, analytical, de-identified, and derivative information generated from use of the App.</p>
              <p>The Company may use such information for:</p>
              <ul>
                <li>research;</li>
                <li>development;</li>
                <li>analytics;</li>
                <li>benchmarking;</li>
                <li>product improvement;</li>
                <li>business planning;</li>
                <li>security monitoring;</li>
                <li>reporting; and</li>
                <li>other lawful business purposes.</li>
              </ul>
              <p>Provided such information does not reasonably identify an individual, these rights survive account deletion.</p>
              <h3>11.10 Open-Source Software</h3>
              <p>Certain components of the App may incorporate open-source software licensed under separate open-source licenses.</p>
              <p>To the extent required by applicable open-source licenses, those licenses shall govern the applicable software components.</p>
              <p>Nothing in these Terms limits rights granted under such licenses.</p>
              <h3>11.11 Reservation of Rights</h3>
              <p>The Company reserves all rights not expressly granted under these Terms.</p>
              <p>No license, right, title, ownership interest, or other intellectual property interest shall be implied by estoppel, waiver, course of dealing, or otherwise.</p>
              <h3>11.12 Protection of Intellectual Property</h3>
              <p>The Company reserves the right to investigate and pursue any unauthorized use of the App or infringement of its intellectual property rights.</p>
              <p>The Company may seek:</p>
              <ul>
                <li>injunctive relief;</li>
                <li>equitable relief;</li>
                <li>damages;</li>
                <li>account suspension;</li>
                <li>account termination; and</li>
                <li>any other remedy available at law or in equity.</li>
              </ul>
              <h3>11.13 Survival</h3>
              <p>The provisions of this Section shall survive termination of these Terms and any user’s access to the App.</p>
              <p>12. Disclaimers and No Warranties</p>
              <h3>12.1 General Disclaimer</h3>
              <p>TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE APP IS PROVIDED ON AN &quot;AS IS,&quot; &quot;AS AVAILABLE,&quot; AND &quot;WITH ALL FAULTS&quot; BASIS.</p>
              <h2>THE COMPANY MAKES NO REPRESENTATIONS, WARRANTIES, CONDITIONS, GUARANTEES, OR UNDERTAKINGS OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY, COLLATERAL, OR OTHERWISE.</h2>
              <h2>TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE COMPANY DISCLAIMS ALL IMPLIED WARRANTIES AND CONDITIONS, INCLUDING:</h2>
              <ul>
                <li>MERCHANTABILITY;</li>
                <li>MERCHANTABLE QUALITY;</li>
                <li>FITNESS FOR A PARTICULAR PURPOSE;</li>
                <li>FITNESS FOR A PARTICULAR USE;</li>
                <li>DURABILITY;</li>
                <li>TITLE;</li>
                <li>NON-INFRINGEMENT;</li>
                <li>COMPATIBILITY;</li>
                <li>SECURITY;</li>
                <li>ACCURACY;</li>
                <li>RELIABILITY; AND</li>
                <li>QUIET ENJOYMENT.</li>
              </ul>
              <h3>12.2 Monitoring Functionality Disclaimer</h3>
              <p>The Company does not warrant that:</p>
              <ul>
                <li>Active Guard will detect all activity;</li>
                <li>Active Guard will detect all use of Monitored Apps;</li>
                <li>monitoring results will be accurate;</li>
                <li>monitoring results will be complete;</li>
                <li>monitoring results will be uninterrupted;</li>
                <li>monitoring functionality will remain available on all devices;</li>
                <li>monitoring functionality will remain available following operating-system updates;</li>
                <li>monitoring functionality will function identically across all devices; or</li>
                <li>monitoring functionality will satisfy the expectations of any user.</li>
              </ul>
              <p>Monitoring results may be affected by technical limitations, permissions, operating-system restrictions, user actions, device settings, network interruptions, hardware limitations, software defects, third-party platform changes, and other circumstances beyond the Company’s control.</p>
              <h3>12.3 No Parenting, Educational, Behavioural, or Child-Development Warranty</h3>
              <p>The App is a family-management tool only.</p>
              <p>The Company does not warrant or represent that use of the App will:</p>
              <ul>
                <li>reduce screen time;</li>
                <li>improve behaviour;</li>
                <li>improve discipline;</li>
                <li>improve academic performance;</li>
                <li>improve concentration;</li>
                <li>improve attention span;</li>
                <li>improve physical activity;</li>
                <li>improve sleep habits;</li>
                <li>improve family relationships;</li>
                <li>improve child development;</li>
                <li>improve parenting outcomes; or</li>
                <li>achieve any specific objective.</li>
              </ul>
              <p>The Company does not provide parenting advice, educational advice, behavioural advice, developmental advice, counselling services, childcare services, supervision services, or family-management services.</p>
              <h3>12.4 No Child-Safety Warranty</h3>
              <p>The Company does not warrant that the App will:</p>
              <ul>
                <li>protect children from harm;</li>
                <li>prevent exposure to inappropriate content;</li>
                <li>prevent cyberbullying;</li>
                <li>prevent online exploitation;</li>
                <li>prevent self-harm;</li>
                <li>prevent addiction;</li>
                <li>prevent criminal conduct;</li>
                <li>detect emergencies;</li>
                <li>identify dangerous situations; or</li>
                <li>otherwise ensure the safety of any child.</li>
              </ul>
              <p>Parents and guardians remain solely responsible for supervising children and making decisions concerning their safety and well-being.</p>
              <h3>12.5 Analytics Disclaimer</h3>
              <p>The Company does not warrant the accuracy, completeness, reliability, timeliness, usefulness, or suitability of:</p>
              <ul>
                <li>analytics;</li>
                <li>reports;</li>
                <li>dashboards;</li>
                <li>streak calculations;</li>
                <li>reward calculations;</li>
                <li>earning calculations;</li>
                <li>activity metrics;</li>
                <li>recommendations;</li>
                <li>insights;</li>
                <li>notifications; or</li>
                <li>other information generated by the App.</li>
              </ul>
              <p>Analytics are informational estimates only and should not be relied upon as definitive records or professional advice.</p>
              <h3>12.6 Active Boost Disclaimer</h3>
              <p>Active Boost and any activity-related features are provided solely for motivational and informational purposes.</p>
              <p>The Company does not warrant the accuracy of:</p>
              <ul>
                <li>step counts;</li>
                <li>active minutes;</li>
                <li>activity measurements;</li>
                <li>exercise calculations;</li>
                <li>fitness metrics; or</li>
                <li>health-related information.</li>
              </ul>
              <p>The App is not a medical device, health-monitoring service, diagnostic tool, or fitness program.</p>
              <p>Nothing contained within the App constitutes medical advice, health advice, or professional healthcare advice.</p>
              <h3>12.7 Third-Party Services Disclaimer</h3>
              <p>The App relies upon Third-Party Providers, including operating systems, cloud providers, analytics providers, authentication providers, payment providers, marketplaces, internet service providers, and other service providers.</p>
              <p>The Company does not warrant:</p>
              <ul>
                <li>the availability of Third-Party Providers;</li>
                <li>the security of Third-Party Providers;</li>
                <li>the performance of Third-Party Providers;</li>
                <li>the reliability of Third-Party Providers; or</li>
                <li>continued access to Third-Party Providers.</li>
              </ul>
              <p>The Company is not responsible for outages, interruptions, restrictions, policy changes, API modifications, account suspensions, or service failures attributable to Third-Party Providers.</p>
              <h3>12.8 Availability Disclaimer</h3>
              <p>The Company does not warrant that the App will:</p>
              <ul>
                <li>be available at all times;</li>
                <li>operate without interruption;</li>
                <li>operate without delay;</li>
                <li>remain compatible with all devices;</li>
                <li>remain compatible with future operating-system versions;</li>
                <li>remain free from defects;</li>
                <li>remain free from errors; or</li>
                <li>continue to be offered indefinitely.</li>
              </ul>
              <p>The Company reserves the right to modify, suspend, discontinue, restrict, or remove features at any time.</p>
              <h3>12.9 Security Disclaimer</h3>
              <p>Although the Company employs security measures designed to protect information, the Company does not warrant that:</p>
              <ul>
                <li>the App is immune from cybersecurity threats;</li>
                <li>information will never be accessed without authorization;</li>
                <li>information will never be lost;</li>
                <li>information will never be altered;</li>
                <li>information will never be disclosed improperly; or</li>
                <li>security incidents will never occur.</li>
              </ul>
              <p>No software application, cloud service, network, or electronic communication system can be guaranteed to be completely secure.</p>
              <h3>12.10 No Financial Warranty</h3>
              <p>The Company does not warrant that:</p>
              <ul>
                <li>any child will earn a particular amount;</li>
                <li>any reward will be achieved;</li>
                <li>any allowance calculation will be accurate;</li>
                <li>any payment will occur;</li>
                <li>any savings goal will be achieved; or</li>
                <li>any financial outcome will result from use of the App.</li>
              </ul>
              <p>The Ledger is informational only and should not be relied upon as a financial record.</p>
              <h3>12.11 Beta Features</h3>
              <p>Any beta, preview, experimental, pilot, early-access, or test feature is provided without warranty of any kind.</p>
              <p>Such features may:</p>
              <ul>
                <li>contain defects;</li>
                <li>be incomplete;</li>
                <li>operate unpredictably;</li>
                <li>be modified without notice; or</li>
                <li>be discontinued at any time.</li>
              </ul>
              <p>Use of beta features is entirely at the user’s risk.</p>
              <h3>12.12 Jurisdictional Limitations</h3>
              <p>Some jurisdictions do not permit the exclusion of certain warranties, conditions, guarantees, or statutory rights.</p>
              <p>Accordingly, some of the exclusions contained in this Section may not apply to certain users.</p>
              <p>Where applicable law prohibits exclusion of a warranty or condition, such warranty or condition shall be limited to the minimum extent permitted by law.</p>
              <h3>12.13 No Reliance</h3>
              <p>Users acknowledge that they have not relied upon any representation, statement, promise, projection, estimate, marketing material, demonstration, recommendation, or expectation not expressly set out in these Terms.</p>
              <p>The Company disclaims responsibility for any reliance placed upon information not expressly incorporated into these Terms.</p>
              <h3>12.14 Survival</h3>
              <p>The provisions of this Section shall survive termination of these Terms and termination of access to the App.</p>
              <p>13. Limitation of Liability</p>
              <h3>13.1 Allocation of Risk</h3>
              <p>You acknowledge and agree that the disclaimers, exclusions, limitations, and allocations of risk contained in these Terms are a fundamental basis of the agreement between you and the Company.</p>
              <p>You further acknowledge that:</p>
              <ul>
                <li>the App is made available at the pricing offered by the Company in reliance upon these limitations;</li>
                <li>the Company would not be able to provide the App on the same terms without such limitations; and</li>
                <li>the limitations contained in this Section are reasonable in light of the nature of the App and the risks associated with its use.</li>
              </ul>
              <h3>13.2 Exclusion of Certain Damages</h3>
              <h2>TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE COMPANY, ITS AFFILIATES, LICENSORS, SERVICE PROVIDERS, DIRECTORS, OFFICERS, EMPLOYEES, CONTRACTORS, CONSULTANTS, SHAREHOLDERS, AGENTS, SUCCESSORS, AND ASSIGNS SHALL NOT BE LIABLE FOR ANY:</h2>
              <ul>
                <li>INDIRECT DAMAGES;</li>
                <li>INCIDENTAL DAMAGES;</li>
                <li>SPECIAL DAMAGES;</li>
                <li>CONSEQUENTIAL DAMAGES;</li>
                <li>EXEMPLARY DAMAGES;</li>
                <li>PUNITIVE DAMAGES;</li>
                <li>AGGRAVATED DAMAGES;</li>
                <li>MULTIPLE DAMAGES;</li>
                <li>LOSS OF PROFITS;</li>
                <li>LOSS OF REVENUE;</li>
                <li>LOSS OF BUSINESS OPPORTUNITY;</li>
                <li>LOSS OF GOODWILL;</li>
                <li>LOSS OF DATA;</li>
                <li>LOSS OF SAVINGS;</li>
                <li>LOSS OF EXPECTED BENEFITS;</li>
                <li>LOSS OF USE;</li>
                <li>BUSINESS INTERRUPTION;</li>
                <li>REPUTATIONAL HARM; OR</li>
                <li>SIMILAR DAMAGES</li>
              </ul>
              <h2>ARISING FROM OR RELATING TO THE APP, REGARDLESS OF THE LEGAL THEORY ASSERTED AND EVEN IF THE COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.</h2>
              <h3>13.3 Specific Exclusions</h3>
              <p>Without limiting the generality of Section 13.2, the Company shall not be liable for any loss, claim, damage, expense, injury, or liability arising from or relating to:</p>
              <ul>
                <li>monitoring inaccuracies;</li>
                <li>monitoring interruptions;</li>
                <li>failures of Active Guard;</li>
                <li>failures of Active Boost;</li>
                <li>inaccurate analytics;</li>
                <li>inaccurate Ledger entries;</li>
                <li>inaccurate reward calculations;</li>
                <li>inaccurate allowance calculations;</li>
                <li>unauthorized account access;</li>
                <li>unauthorized device access;</li>
                <li>data loss;</li>
                <li>data corruption;</li>
                <li>cybersecurity incidents;</li>
                <li>child behavioural outcomes;</li>
                <li>parenting decisions;</li>
                <li>educational outcomes;</li>
                <li>family disputes;</li>
                <li>custody disputes;</li>
                <li>guardianship disputes;</li>
                <li>child-safety incidents;</li>
                <li>exposure to inappropriate content;</li>
                <li>online activity of a child;</li>
                <li>user reliance on Analytics Features;</li>
                <li>third-party service failures;</li>
                <li>operating-system changes;</li>
                <li>API changes;</li>
                <li>app-store actions;</li>
                <li>account suspensions;</li>
                <li>subscription disputes;</li>
                <li>payment disputes;</li>
                <li>Virtual Items;</li>
                <li>promotional programs;</li>
                <li>beta features; or</li>
                <li>any act or omission of a third party.</li>
              </ul>
              <h3>13.4 Third-Party Providers</h3>
              <p>To the maximum extent permitted by law, the Company shall not be liable for any loss arising from:</p>
              <ul>
                <li>cloud-hosting providers;</li>
                <li>internet service providers;</li>
                <li>telecommunications providers;</li>
                <li>operating-system providers;</li>
                <li>device manufacturers;</li>
                <li>payment processors;</li>
                <li>analytics providers;</li>
                <li>authentication providers;</li>
                <li>app marketplaces;</li>
                <li>software-development-kit providers; or</li>
                <li>any other Third-Party Provider.</li>
              </ul>
              <p>Any claim arising from the actions or omissions of a Third-Party Provider shall be pursued directly against the applicable provider and not against the Company.</p>
              <h3>13.5 No Liability for Child Conduct</h3>
              <p>The Company shall not be responsible for the actions, conduct, decisions, behaviour, communications, online activity, or offline activity of any child, parent, guardian, family member, or user.</p>
              <p>The Company does not supervise children and assumes no duty of care regarding a child’s activities, conduct, safety, education, development, health, or well-being.</p>
              <h3>13.6 Maximum Aggregate Liability</h3>
              <h2>TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE TOTAL AGGREGATE LIABILITY OF THE COMPANY ARISING OUT OF OR RELATING TO THE APP, THESE TERMS, OR THE RELATIONSHIP BETWEEN THE PARTIES SHALL NOT EXCEED THE GREATER OF:</h2>
              <ul>
                <li>(a) ONE HUNDRED CANADIAN DOLLARS (CAD $100.00); OR</li>
                <li>(b) THE TOTAL FEES ACTUALLY PAID BY THE CLAIMANT TO THE COMPANY DURING THE TWELVE (12) MONTH PERIOD IMMEDIATELY PRECEDING THE EVENT GIVING RISE TO THE CLAIM.</li>
              </ul>
              <p>The foregoing limitation applies collectively to all claims, causes of action, losses, damages, and liabilities.</p>
              <h3>13.7 Single Recovery</h3>
              <p>A claimant may recover only once in respect of the same loss, regardless of:</p>
              <ul>
                <li>the number of legal theories asserted;</li>
                <li>the number of claims advanced;</li>
                <li>the number of users involved;</li>
                <li>the number of accounts involved; or</li>
                <li>the number of incidents alleged.</li>
              </ul>
              <h3>13.8 Limitation Period</h3>
              <p>To the maximum extent permitted by law, any claim arising from or relating to the App must be commenced within one (1) year after the claim first arose or ought reasonably to have been discovered.</p>
              <p>Any claim not commenced within that period shall be permanently barred.</p>
              <p>This provision applies only to the extent permitted by applicable law.</p>
              <h3>13.9 Failure of Essential Purpose</h3>
              <p>The limitations and exclusions contained in these Terms apply regardless of whether any limited remedy fails of its essential purpose.</p>
              <h3>13.10 Consumer Protection Rights</h3>
              <p>Nothing in these Terms excludes, restricts, or limits any consumer rights, statutory rights, remedies, warranties, guarantees, or protections that cannot lawfully be excluded under applicable law.</p>
              <p>Where applicable law prohibits exclusion or limitation of liability, the Company’s liability shall be limited to the maximum extent permitted by law.</p>
              <h3>13.11 Force Majeure Events</h3>
              <p>The Company shall not be liable for any delay, interruption, failure, damage, or loss resulting from events beyond its reasonable control, including:</p>
              <ul>
                <li>natural disasters;</li>
                <li>pandemics;</li>
                <li>public-health emergencies;</li>
                <li>labour disputes;</li>
                <li>internet failures;</li>
                <li>cyberattacks;</li>
                <li>denial-of-service attacks;</li>
                <li>utility failures;</li>
                <li>governmental actions;</li>
                <li>regulatory actions;</li>
                <li>court orders;</li>
                <li>acts of war;</li>
                <li>civil unrest; or</li>
                <li>failures of Third-Party Providers.</li>
              </ul>
              <h3>13.12 Basis of Bargain</h3>
              <p>The parties acknowledge that the limitations and exclusions contained in this Section constitute an essential basis of the bargain between the parties and shall survive termination of these Terms.</p>
              <h3>13.13 Survival</h3>
              <p>The provisions of this Section shall survive termination of these Terms, deletion of any account, suspension of access to the App, and discontinuation of the App.</p>
              <p>14. Indemnification</p>
              <h3>14.1 User Indemnity</h3>
              <p>To the maximum extent permitted by applicable law, you agree to defend, indemnify, and hold harmless the Company and its affiliates, licensors, service providers, directors, officers, employees, contractors, consultants, agents, successors, and assigns (collectively, the &quot;Indemnified Parties&quot;) from and against any and all claims, demands, actions, proceedings, investigations, complaints, liabilities, damages, losses, judgments, penalties, fines, costs, and expenses (including reasonable legal fees and disbursements on a solicitor-and-client basis) arising out of or relating to:</p>
              <ul>
                <li>your use of the App;</li>
                <li>your misuse of the App;</li>
                <li>your violation of these Terms;</li>
                <li>your violation of applicable law;</li>
                <li>your violation of the rights of any third party;</li>
                <li>information submitted through your account;</li>
                <li>any Child Profile associated with your account;</li>
                <li>your configuration of App settings;</li>
                <li>your monitoring activities;</li>
                <li>your reward or allowance decisions;</li>
                <li>your parenting decisions; or</li>
                <li>any act or omission by you or any person using your account.</li>
              </ul>
              <h3>14.2 Child Profiles and Parental Authority</h3>
              <p>Without limiting Section 14.1, you agree to indemnify the Indemnified Parties against any claim arising from or relating to:</p>
              <ul>
                <li>creation of a Child Profile;</li>
                <li>alleged lack of parental consent;</li>
                <li>alleged lack of guardian consent;</li>
                <li>custody disputes;</li>
                <li>parenting disputes;</li>
                <li>guardianship disputes;</li>
                <li>family-law disputes;</li>
                <li>allegations concerning authority to act on behalf of a child;</li>
                <li>allegations concerning monitoring of a child; or</li>
                <li>alleged violations of privacy rights relating to a child.</li>
              </ul>
              <p>The Company shall be entitled to rely upon representations made by the Parent Account holder regarding parental authority and consent.</p>
              <h3>14.3 Unauthorized Monitoring</h3>
              <p>You agree to indemnify the Indemnified Parties from any claim arising out of or relating to:</p>
              <ul>
                <li>monitoring of an adult;</li>
                <li>monitoring of a spouse or former spouse;</li>
                <li>monitoring of a partner or former partner;</li>
                <li>monitoring of an employee;</li>
                <li>monitoring of a contractor;</li>
                <li>monitoring of a tenant;</li>
                <li>monitoring of any individual without lawful authority;</li>
                <li>violations of privacy legislation;</li>
                <li>violations of surveillance laws; or</li>
                <li>alleged unauthorized collection of information.</li>
              </ul>
              <p>This indemnity applies regardless of whether the claim is brought by the monitored individual, a regulator, a governmental authority, or any third party.</p>
              <h3>14.4 User Content and Information</h3>
              <p>You agree to indemnify the Indemnified Parties against claims arising from:</p>
              <ul>
                <li>information submitted through the App;</li>
                <li>User Content;</li>
                <li>inaccurate information;</li>
                <li>misleading information;</li>
                <li>unlawful information;</li>
                <li>defamatory information;</li>
                <li>intellectual property infringement;</li>
                <li>privacy complaints;</li>
                <li>regulatory complaints; or</li>
                <li>allegations that information provided by you violates applicable law.</li>
              </ul>
              <h3>14.5 Reward and Payment Disputes</h3>
              <p>You agree to indemnify the Indemnified Parties against claims arising from:</p>
              <ul>
                <li>rewards;</li>
                <li>allowances;</li>
                <li>payments;</li>
                <li>Ledger entries;</li>
                <li>earning calculations;</li>
                <li>reward disputes;</li>
                <li>family financial disputes;</li>
                <li>alleged promises made to a child;</li>
                <li>alleged failures to pay rewards; or</li>
                <li>any dispute between a parent and child concerning incentives, compensation, gifts, rewards, or allowances.</li>
              </ul>
              <p>The Company is not a party to any arrangement between a parent and child relating to rewards or payments.</p>
              <h3>14.6 Third-Party Claims</h3>
              <p>The indemnities contained in this Section apply to claims brought by:</p>
              <ul>
                <li>children;</li>
                <li>parents;</li>
                <li>guardians;</li>
                <li>family members;</li>
                <li>users;</li>
                <li>former users;</li>
                <li>third parties;</li>
                <li>governmental authorities;</li>
                <li>regulators;</li>
                <li>law-enforcement agencies; and</li>
                <li>any other person asserting a claim.</li>
              </ul>
              <h3>14.7 Intellectual Property Claims</h3>
              <p>You agree to indemnify the Indemnified Parties from claims arising from:</p>
              <ul>
                <li>infringement of intellectual property rights;</li>
                <li>misuse of Company intellectual property;</li>
                <li>unauthorized reproduction of the App;</li>
                <li>reverse engineering;</li>
                <li>scraping activities;</li>
                <li>unauthorized commercial use; or</li>
                <li>violation of Section 11 of these Terms.</li>
              </ul>
              <h3>14.8 Regulatory Matters</h3>
              <p>You agree to indemnify the Indemnified Parties against:</p>
              <ul>
                <li>regulatory investigations;</li>
                <li>administrative proceedings;</li>
                <li>governmental inquiries;</li>
                <li>privacy complaints;</li>
                <li>consumer protection complaints;</li>
                <li>child protection complaints;</li>
                <li>sanctions investigations; and</li>
                <li>similar proceedings</li>
              </ul>
              <p>to the extent arising from your conduct, your account, your Child Profiles, or your violation of these Terms.</p>
              <h3>14.9 Defense of Claims</h3>
              <p>The Company reserves the right, at its own expense, to assume the exclusive defense and control of any matter otherwise subject to indemnification by you.</p>
              <p>Where the Company elects to assume such defense:</p>
              <ul>
                <li>you shall cooperate fully;</li>
                <li>you shall provide information reasonably requested;</li>
                <li>you shall preserve relevant records; and</li>
                <li>you shall not settle any claim without the Company’s prior written consent.</li>
              </ul>
              <h3>14.10 Settlement Restrictions</h3>
              <p>You shall not settle any claim subject to this Section without the prior written consent of the Company if the settlement:</p>
              <ul>
                <li>imposes liability upon an Indemnified Party;</li>
                <li>imposes obligations upon an Indemnified Party;</li>
                <li>admits fault on behalf of an Indemnified Party;</li>
                <li>restricts the rights of an Indemnified Party; or</li>
                <li>otherwise adversely affects an Indemnified Party.</li>
              </ul>
              <h3>14.11 Independent Obligations</h3>
              <p>The indemnification obligations contained in this Section are independent of:</p>
              <ul>
                <li>the limitation of liability provisions;</li>
                <li>the disclaimer provisions;</li>
                <li>the termination provisions; and</li>
                <li>any other rights or remedies available to the Company.</li>
              </ul>
              <h3>14.12 Survival</h3>
              <p>The provisions of this Section shall survive:</p>
              <ul>
                <li>termination of these Terms;</li>
                <li>deletion of any account;</li>
                <li>suspension of access to the App;</li>
                <li>discontinuation of the App; and</li>
                <li>the conclusion of any relationship between the parties.</li>
              </ul>
              <p>15. Account Suspension, Restriction, Termination and Discontinuance</p>
              <h3>15.1 Right to Suspend or Terminate</h3>
              <p>The Company reserves the right, at any time and in its sole discretion, to suspend, restrict, disable, investigate, limit, or terminate:</p>
              <ul>
                <li>any account;</li>
                <li>any Parent Account;</li>
                <li>any Child Profile;</li>
                <li>any Family Group;</li>
                <li>any subscription;</li>
                <li>any feature;</li>
                <li>any integration;</li>
                <li>any Virtual Item;</li>
                <li>any reward program; or</li>
                <li>access to the App generally</li>
              </ul>
              <p>where the Company reasonably believes such action is necessary or appropriate.</p>
              <h3>15.2 Grounds for Suspension or Termination</h3>
              <p>Without limiting Section 15.1, the Company may suspend, restrict, or terminate access where:</p>
              <ul>
                <li>these Terms are violated;</li>
                <li>applicable law is violated;</li>
                <li>the Company receives a legal complaint;</li>
                <li>unauthorized monitoring is suspected;</li>
                <li>parental authority is disputed;</li>
                <li>custody or guardianship disputes arise;</li>
                <li>child-safety concerns arise;</li>
                <li>fraudulent activity is suspected;</li>
                <li>security concerns arise;</li>
                <li>false information has been provided;</li>
                <li>payment obligations remain outstanding;</li>
                <li>a subscription is cancelled or expires;</li>
                <li>a chargeback is initiated;</li>
                <li>misuse of Virtual Items occurs;</li>
                <li>the Company receives a regulatory inquiry;</li>
                <li>the Company receives a privacy complaint;</li>
                <li>account activity presents risk to the App;</li>
                <li>operation of the account could expose the Company to liability; or</li>
                <li>continued access is otherwise deemed inappropriate by the Company.</li>
              </ul>
              <h3>15.3 Child Protection Measures</h3>
              <p>The Company may immediately suspend or restrict access where it reasonably believes that:</p>
              <ul>
                <li>a Child Profile was created without valid parental authorization;</li>
                <li>required consent has been withdrawn;</li>
                <li>parental authority is disputed;</li>
                <li>information relating to a child has been provided improperly;</li>
                <li>use of the App may violate applicable child-protection laws; or</li>
                <li>suspension is reasonably necessary to protect a child.</li>
              </ul>
              <p>The Company shall not be obligated to investigate or adjudicate disputes concerning parental authority, guardianship, custody, or family-law matters.</p>
              <h3>15.4 Security and Fraud Investigations</h3>
              <p>The Company may suspend access while investigating:</p>
              <ul>
                <li>suspected fraud;</li>
                <li>suspected misuse;</li>
                <li>unauthorized access;</li>
                <li>cybersecurity incidents;</li>
                <li>account compromise;</li>
                <li>manipulation of rewards;</li>
                <li>manipulation of analytics;</li>
                <li>manipulation of Ledger entries;</li>
                <li>abuse of promotional programs; or</li>
                <li>other conduct that may adversely affect the App.</li>
              </ul>
              <p>Users agree to cooperate with reasonable investigations conducted by the Company.</p>
              <h3>15.5 Subscription Suspension</h3>
              <p>The Company may suspend or restrict access to paid features where:</p>
              <ul>
                <li>payment fails;</li>
                <li>a subscription expires;</li>
                <li>a subscription is cancelled;</li>
                <li>a payment dispute is initiated;</li>
                <li>a chargeback occurs; or</li>
                <li>billing information becomes invalid.</li>
              </ul>
              <p>The Company shall not be responsible for any loss resulting from suspension of subscription-related features.</p>
              <h3>15.6 Regulatory and Legal Compliance</h3>
              <p>The Company may suspend, restrict, or terminate access where required or permitted by:</p>
              <ul>
                <li>applicable law;</li>
                <li>court order;</li>
                <li>subpoena;</li>
                <li>regulatory request;</li>
                <li>law-enforcement request;</li>
                <li>privacy authority request;</li>
                <li>app-store requirement; or</li>
                <li>governmental directive.</li>
              </ul>
              <p>The Company shall not be liable for actions taken in good-faith compliance with legal obligations.</p>
              <h3>15.7 No Obligation to Maintain Accounts</h3>
              <p>The Company is under no obligation to maintain:</p>
              <ul>
                <li>any account;</li>
                <li>any Child Profile;</li>
                <li>any historical record;</li>
                <li>any Ledger entry;</li>
                <li>any analytics data;</li>
                <li>any Virtual Item;</li>
                <li>any reward balance; or</li>
                <li>any App feature</li>
              </ul>
              <p>for any specific period of time unless otherwise required by law.</p>
              <h3>15.8 User-Initiated Termination</h3>
              <p>Users may terminate their account at any time by:</p>
              <ul>
                <li>deleting the account through available App functionality; or</li>
                <li>contacting the Company using the contact information provided in these Terms.</li>
              </ul>
              <p>Termination requests may require identity verification.</p>
              <p>The Company may retain information following termination in accordance with these Terms, the Privacy Policy, and applicable law.</p>
              <h3>15.9 Effect of Termination</h3>
              <p>Upon termination or suspension:</p>
              <ul>
                <li>access to the App may cease immediately;</li>
                <li>subscriptions may be cancelled;</li>
                <li>Child Profiles may be disabled;</li>
                <li>access to Analytics Features may cease;</li>
                <li>access to historical information may cease;</li>
                <li>Virtual Items may be removed;</li>
                <li>rewards may be forfeited;</li>
                <li>licenses granted under these Terms shall terminate; and</li>
                <li>the Company may disable account credentials.</li>
              </ul>
              <p>The Company shall have no obligation to restore terminated accounts.</p>
              <h3>15.10 Data Following Termination</h3>
              <p>Following termination, the Company may:</p>
              <ul>
                <li>retain information;</li>
                <li>archive information;</li>
                <li>anonymize information;</li>
                <li>de-identify information;</li>
                <li>delete information; or</li>
                <li>restrict access to information</li>
              </ul>
              <p>in accordance with applicable law, internal retention policies, security requirements, legal obligations, and the Privacy Policy.</p>
              <h3>15.11 Discontinuance of the App</h3>
              <p>The Company reserves the right to modify, suspend, discontinue, replace, or permanently cease operation of the App, in whole or in part, at any time.</p>
              <p>The Company shall not be liable for any loss arising from:</p>
              <ul>
                <li>discontinuance of the App;</li>
                <li>discontinuance of a feature;</li>
                <li>discontinuance of an integration;</li>
                <li>discontinuance of a subscription;</li>
                <li>discontinuance of a Virtual Item;</li>
                <li>discontinuance of analytics features; or</li>
                <li>discontinuance of monitoring functionality.</li>
              </ul>
              <h3>15.12 No Refund Upon Termination</h3>
              <p>Except where required by applicable law, termination, suspension, restriction, discontinuance, or removal of access does not entitle a user to:</p>
              <ul>
                <li>compensation;</li>
                <li>damages;</li>
                <li>reimbursement;</li>
                <li>restoration of Virtual Items;</li>
                <li>restoration of rewards; or</li>
                <li>refund of fees previously paid.</li>
              </ul>
              <p>Any refund rights shall be governed by applicable law and any applicable marketplace requirements.</p>
              <h3>15.13 Survival of Certain Provisions</h3>
              <p>Termination shall not affect provisions of these Terms which by their nature are intended to survive termination, including:</p>
              <ul>
                <li>intellectual property provisions;</li>
                <li>disclaimer provisions;</li>
                <li>limitation of liability provisions;</li>
                <li>indemnification provisions;</li>
                <li>dispute-resolution provisions;</li>
                <li>privacy-related obligations;</li>
                <li>payment obligations;</li>
                <li>confidentiality obligations; and</li>
                <li>any other provision intended to survive.</li>
              </ul>
              <h3>15.14 Reservation of Rights</h3>
              <p>The rights provided in this Section are cumulative and in addition to any other rights or remedies available to the Company at law, in equity, under contract, or otherwise.</p>
              <p>16. Governing Law, Dispute Resolution and Arbitration</p>
              <h3>16.1 Governing Law</h3>
              <p>These Terms, the App, and any dispute, claim, controversy, or cause of action arising out of or relating to the App or these Terms shall be governed by and construed in accordance with:</p>
              <ul>
                <li>(a) the laws of the Province of Ontario; and</li>
                <li>(b) the federal laws of Canada applicable therein,</li>
              </ul>
              <p>without regard to conflict-of-law principles.</p>
              <p>The United Nations Convention on Contracts for the International Sale of Goods does not apply.</p>
              <h3>16.2 Good-Faith Resolution</h3>
              <p>Before commencing arbitration, litigation, or other formal proceedings, the parties agree to attempt in good faith to resolve any dispute informally.</p>
              <p>A party seeking to raise a dispute shall first provide written notice to the other party containing:</p>
              <ul>
                <li>a description of the dispute;</li>
                <li>the factual basis of the dispute;</li>
                <li>the relief sought; and</li>
                <li>contact information for the complaining party.</li>
              </ul>
              <p>The parties shall attempt in good faith to resolve the dispute within thirty (30) days following receipt of the notice.</p>
              <p>Nothing in this Section prevents either party from seeking urgent injunctive or equitable relief where necessary to prevent immediate harm.</p>
              <h3>16.3 Small Claims Court</h3>
              <p>Notwithstanding any other provision of these Terms, either party may bring an eligible claim in a court having Small Claims Court jurisdiction where:</p>
              <ul>
                <li>the claim falls within the applicable monetary limits;</li>
                <li>the claim qualifies for Small Claims Court procedures; and</li>
                <li>applicable law permits such proceedings.</li>
              </ul>
              <p>The parties acknowledge that Small Claims Court proceedings may provide a cost-effective mechanism for resolving certain disputes.</p>
              <h3>16.4 Arbitration</h3>
              <p>Subject to Sections 16.2 and 16.3, any dispute arising from or relating to:</p>
              <ul>
                <li>these Terms;</li>
                <li>the App;</li>
                <li>subscriptions;</li>
                <li>Virtual Items;</li>
                <li>Analytics Features;</li>
                <li>Child Profiles;</li>
                <li>Parent Accounts; or</li>
                <li>the relationship between the parties</li>
              </ul>
              <p>shall be resolved by final and binding arbitration to the extent permitted by applicable law.</p>
              <p>Arbitration shall be conducted:</p>
              <ul>
                <li>in Toronto, Ontario;</li>
                <li>in the English language;</li>
                <li>before a single arbitrator; and</li>
                <li>pursuant to the arbitration legislation applicable in Ontario.</li>
              </ul>
              <p>The arbitrator shall have authority to award any remedy available under applicable law, subject to the limitations contained in these Terms.</p>
              <p>The arbitrator shall not have authority to modify these Terms.</p>
              <h3>16.5 Consumer Protection Rights</h3>
              <p>Nothing in these Terms is intended to:</p>
              <ul>
                <li>waive non-waivable consumer rights;</li>
                <li>waive statutory rights;</li>
                <li>waive mandatory legal protections; or</li>
                <li>prevent a consumer from exercising rights that cannot lawfully be restricted.</li>
              </ul>
              <p>To the extent that mandatory consumer-protection legislation prohibits arbitration or requires access to a court or tribunal, such legislation shall prevail.</p>
              <h3>16.6 Class Action Waiver</h3>
              <p>To the maximum extent permitted by applicable law, disputes shall be resolved on an individual basis.</p>
              <p>Users agree not to participate in:</p>
              <ul>
                <li>class actions;</li>
                <li>class arbitrations;</li>
                <li>representative proceedings;</li>
                <li>mass claims; or</li>
                <li>consolidated proceedings</li>
              </ul>
              <p>except where such restrictions are prohibited by applicable law.</p>
              <p>Where applicable law prohibits enforcement of this Section, the unenforceable portion shall be severed while the remainder of these Terms continues in effect.</p>
              <h3>16.7 Injunctive Relief</h3>
              <p>Nothing in these Terms prevents either party from seeking:</p>
              <ul>
                <li>injunctive relief;</li>
                <li>equitable relief;</li>
                <li>preservation orders;</li>
                <li>confidentiality orders;</li>
                <li>intellectual-property protection orders; or</li>
                <li>similar remedies</li>
              </ul>
              <p>from a court of competent jurisdiction where such relief is necessary to protect legal rights pending final resolution of a dispute.</p>
              <h3>16.8 Jurisdiction for Court Proceedings</h3>
              <p>Where arbitration is unavailable, unenforceable, prohibited by law, or otherwise inapplicable, the parties irrevocably attorn to the exclusive jurisdiction of the courts of Ontario.</p>
              <p>Subject to applicable law, proceedings shall be commenced in Toronto, Ontario.</p>
              <h3>16.9 Limitation Period</h3>
              <p>To the maximum extent permitted by law, any claim arising from or relating to the App must be commenced within one (1) year after the claim first arose or ought reasonably to have been discovered.</p>
              <p>This provision applies only to the extent permitted by applicable law and shall not override any mandatory limitation period established by statute.</p>
              <h3>16.10 Recovery of Costs</h3>
              <p>The arbitrator or court may award costs, legal fees, disbursements, and expenses only to the extent permitted by applicable law and applicable procedural rules.</p>
              <h3>16.11 Confidentiality of Proceedings</h3>
              <p>To the extent permitted by law, the parties agree to keep confidential:</p>
              <ul>
                <li>arbitration proceedings;</li>
                <li>settlement discussions;</li>
                <li>mediation discussions;</li>
                <li>confidential evidence;</li>
                <li>proprietary information; and</li>
                <li>non-public decisions</li>
              </ul>
              <p>except where disclosure is required by law or reasonably necessary to enforce rights.</p>
              <h3>16.12 Severability</h3>
              <p>If any portion of this Section is determined to be invalid, unenforceable, or contrary to applicable law, the remainder of this Section shall continue in full force and effect to the maximum extent permitted by law.</p>
              <h3>16.13 Survival</h3>
              <p>The provisions of this Section shall survive:</p>
              <ul>
                <li>termination of these Terms;</li>
                <li>deletion of accounts;</li>
                <li>discontinuance of the App;</li>
                <li>suspension of services; and</li>
                <li>the conclusion of any relationship between the parties.</li>
              </ul>
              <p>17. Changes to These Terms</p>
              <h3>17.1 Entire Agreement</h3>
              <p>These Terms, together with:</p>
              <ul>
                <li>the Privacy Policy;</li>
                <li>any supplemental terms;</li>
                <li>subscription terms;</li>
                <li>marketplace terms incorporated by reference; and</li>
                <li>any additional policies expressly incorporated into these Terms</li>
              </ul>
              <p>constitute the entire agreement between the parties concerning the App.</p>
              <p>These Terms supersede all prior and contemporaneous:</p>
              <ul>
                <li>discussions;</li>
                <li>negotiations;</li>
                <li>understandings;</li>
                <li>representations;</li>
                <li>communications; and</li>
                <li>agreements</li>
              </ul>
              <p>relating to the App.</p>
              <h3>17.2 Assignment</h3>
              <p>The Company may assign, transfer, delegate, subcontract, or otherwise dispose of any rights or obligations under these Terms without notice and without obtaining user consent.</p>
              <p>Users may not assign, transfer, delegate, sublicense, or otherwise dispose of any rights or obligations under these Terms without the Company’s prior written consent.</p>
              <p>Any purported assignment in violation of this Section shall be void.</p>
              <h3>17.3 Successors and Assigns</h3>
              <p>These Terms shall enure to the benefit of and be binding upon:</p>
              <ul>
                <li>the parties;</li>
                <li>their successors;</li>
                <li>their permitted assigns;</li>
                <li>their heirs;</li>
                <li>their executors;</li>
                <li>their administrators; and</li>
                <li>their legal representatives,</li>
              </ul>
              <p>where applicable.</p>
              <h3>17.4 No Waiver</h3>
              <p>Failure by the Company to exercise or enforce any right, remedy, power, or provision of these Terms shall not constitute:</p>
              <ul>
                <li>a waiver;</li>
                <li>an election;</li>
                <li>an estoppel; or</li>
                <li>a relinquishment of rights.</li>
              </ul>
              <p>Any waiver must be in writing and signed by an authorized representative of the Company.</p>
              <p>A waiver on one occasion shall not constitute a waiver on any future occasion.</p>
              <h3>17.5 Severability</h3>
              <p>If any provision of these Terms is determined to be:</p>
              <ul>
                <li>invalid;</li>
                <li>illegal;</li>
                <li>unenforceable; or</li>
                <li>contrary to applicable law,</li>
              </ul>
              <p>that provision shall be interpreted, modified, limited, or severed to the minimum extent necessary to preserve its validity and enforceability.</p>
              <p>The remainder of these Terms shall continue in full force and effect.</p>
              <h3>17.6 Interpretation</h3>
              <p>Unless the context requires otherwise:</p>
              <ul>
                <li>headings are for convenience only and do not affect interpretation;</li>
                <li>the singular includes the plural and vice versa;</li>
                <li>references to a gender include all genders;</li>
                <li>references to legislation include amendments, replacements, and successor legislation;</li>
                <li>&quot;including&quot; means &quot;including without limitation&quot;;</li>
                <li>&quot;includes&quot; means &quot;includes without limitation&quot;; and</li>
                <li>references to writing include electronic communications.</li>
              </ul>
              <p>These Terms shall not be interpreted against either party solely because that party drafted them.</p>
              <h3>17.7 Electronic Records and Signatures</h3>
              <p>Users consent to:</p>
              <ul>
                <li>electronic contracting;</li>
                <li>electronic records;</li>
                <li>electronic notices;</li>
                <li>electronic signatures; and</li>
                <li>electronic communications.</li>
              </ul>
              <p>Electronic acceptance of these Terms shall have the same legal effect as a handwritten signature.</p>
              <p>Users agree that electronic records may be used as evidence in legal proceedings to the same extent as paper records.</p>
              <h3>17.8 Notices</h3>
              <p>The Company may provide notices by:</p>
              <ul>
                <li>email;</li>
                <li>push notification;</li>
                <li>in-App notification;</li>
                <li>website posting;</li>
                <li>account messaging; or</li>
                <li>other electronic means.</li>
              </ul>
              <p>Notice shall be deemed received:</p>
              <ul>
                <li>immediately when delivered through the App;</li>
                <li>immediately when delivered through a push notification;</li>
                <li>on the date sent by email; or</li>
                <li>on the date posted where posting constitutes a reasonable method of notice.</li>
              </ul>
              <p>Users are responsible for maintaining accurate contact information.</p>
              <h3>17.9 Relationship of the Parties</h3>
              <p>Nothing in these Terms creates:</p>
              <ul>
                <li>an employment relationship;</li>
                <li>an agency relationship;</li>
                <li>a partnership;</li>
                <li>a joint venture;</li>
                <li>a fiduciary relationship;</li>
                <li>a trustee-beneficiary relationship;</li>
                <li>a financial-services relationship; or</li>
                <li>any other special relationship.</li>
              </ul>
              <p>The parties are independent contracting parties.</p>
              <h3>17.10 No Third-Party Rights</h3>
              <p>Except as expressly stated in these Terms, no person who is not a party to these Terms shall have any right to enforce them.</p>
              <p>Nothing in these Terms confers rights upon:</p>
              <ul>
                <li>children;</li>
                <li>family members;</li>
                <li>third-party providers;</li>
                <li>advertisers;</li>
                <li>service providers; or</li>
                <li>other third parties,</li>
              </ul>
              <p>except where expressly stated.</p>
              <h3>17.11 Apple Third-Party Beneficiary Rights</h3>
              <p>If the App is downloaded through the Apple App Store, Apple Inc. and its affiliated companies shall be third-party beneficiaries of these Terms.</p>
              <p>Upon a user’s acceptance of these Terms, Apple shall have the right to enforce these Terms against the user as a third-party beneficiary.</p>
              <p>Except as expressly provided herein, Apple assumes no responsibility for:</p>
              <ul>
                <li>maintenance;</li>
                <li>support;</li>
                <li>warranty obligations;</li>
                <li>legal compliance; or</li>
                <li>dispute resolution relating to the App.</li>
              </ul>
              <h3>17.12 Force Majeure</h3>
              <p>The Company shall not be liable for any delay, interruption, failure, loss, damage, or inability to perform resulting from events beyond its reasonable control, including:</p>
              <ul>
                <li>natural disasters;</li>
                <li>pandemics;</li>
                <li>public-health emergencies;</li>
                <li>cyberattacks;</li>
                <li>denial-of-service attacks;</li>
                <li>internet outages;</li>
                <li>utility failures;</li>
                <li>telecommunications failures;</li>
                <li>labour disputes;</li>
                <li>civil unrest;</li>
                <li>governmental actions;</li>
                <li>court orders;</li>
                <li>regulatory actions;</li>
                <li>war;</li>
                <li>terrorism;</li>
                <li>acts of God; or</li>
                <li>failures of Third-Party Providers.</li>
              </ul>
              <h3>17.13 Compliance with Laws</h3>
              <p>Users are responsible for complying with all laws applicable to their use of the App.</p>
              <p>The Company makes no representation that the App is lawful in every jurisdiction.</p>
              <p>Accessing the App from jurisdictions where such access is unlawful is prohibited.</p>
              <h3>17.14 Export Controls and Sanctions</h3>
              <p>Users shall not use, export, re-export, transfer, download, access, or make available the App in violation of:</p>
              <ul>
                <li>Canadian export-control laws;</li>
                <li>United States export-control laws;</li>
                <li>economic sanctions laws; or</li>
                <li>other applicable trade restrictions.</li>
              </ul>
              <p>Users represent that they are not located in, ordinarily resident in, or subject to sanctions imposed by any jurisdiction that would prohibit use of the App.</p>
              <h3>17.15 Language</h3>
              <p>The parties expressly agree that these Terms and all related documents shall be drafted and interpreted in the English language.</p>
              <p>Les parties reconnaissent avoir exigé que les présentes conditions et tous les documents connexes soient rédigés en langue anglaise.</p>
              <h3>17.16 Survival</h3>
              <p>Any provision which by its nature is intended to survive termination shall survive termination of these Terms, including:</p>
              <ul>
                <li>intellectual property provisions;</li>
                <li>privacy provisions;</li>
                <li>disclaimers;</li>
                <li>limitations of liability;</li>
                <li>indemnities;</li>
                <li>dispute-resolution provisions;</li>
                <li>payment obligations;</li>
                <li>confidentiality obligations; and</li>
                <li>enforcement provisions.</li>
              </ul>
              <h3>17.17 Contact Information</h3>
              <p>Questions concerning these Terms may be directed to:</p>
              <p>2422019 Ontario Inc. (o/a BuckTime!)</p>
              <p>Email: legal@chachingapp.ca</p>
              <p>Support: support@chachingapp.ca</p>
              <p>The Company may update contact information from time to time by posting revised information through the App or website.</p>
              <h3>17.18 Reservation of Rights</h3>
              <p>The Company reserves all rights not expressly granted under these Terms.</p>
              <p>No right, license, permission, consent, or authorization shall be implied except as expressly set out herein.</p>
              <h2>APP STORE AND MARKETPLACE PROVISIONS</h2>
              <h3>18.1 Application of this Section</h3>
              <p>This Section applies only where the App is obtained through a third-party application marketplace, including:</p>
              <ul>
                <li>Apple App Store;</li>
                <li>Google Play Store; or</li>
                <li>any other authorized marketplace through which the App is distributed.</li>
              </ul>
              <p>To the extent of any conflict between this Section and another provision of these Terms, this Section shall govern with respect to marketplace-related matters.</p>
              <h3>18.2 Apple App Store Acknowledgements</h3>
              <p>Where the App is obtained through the Apple App Store:</p>
              <ul>
                <li>(a) these Terms are concluded solely between the user and the Company and not with Apple Inc.;</li>
                <li>(b) Apple is not responsible for the App or its content;</li>
                <li>(c) Apple has no obligation to provide maintenance or support services for the App;</li>
                <li>(d) Apple has no responsibility for addressing claims relating to the App, including:</li>
                <li>product liability claims;</li>
                <li>consumer claims;</li>
                <li>regulatory claims;</li>
                <li>privacy claims;</li>
                <li>legal compliance claims; and</li>
                <li>intellectual property claims;</li>
                <li>(e) Apple is not responsible for investigating, defending, settling, or discharging any claim that the App infringes third-party intellectual property rights; and</li>
                <li>(f) Apple and its affiliated companies are third-party beneficiaries of these Terms and may enforce these Terms against users.</li>
              </ul>
              <h3>18.3 Google Play Acknowledgements</h3>
              <p>Where the App is obtained through Google Play Store:</p>
              <ul>
                <li>(a) use of the App remains subject to applicable Google Play policies;</li>
                <li>(b) Google is not responsible for support or maintenance of the App except as required by applicable law;</li>
                <li>(c) Google is not responsible for claims relating to the App except as required by applicable law; and</li>
                <li>(d) billing, subscription management, refunds, and payment disputes may be governed by Google Play requirements.</li>
              </ul>
              <h3>18.4 Marketplace Terms</h3>
              <p>Users acknowledge that:</p>
              <ul>
                <li>marketplace operators maintain their own terms and conditions;</li>
                <li>marketplace operators maintain their own privacy policies;</li>
                <li>marketplace operators maintain their own billing policies;</li>
                <li>marketplace operators maintain their own refund procedures; and</li>
                <li>marketplace operators may impose requirements independent of these Terms.</li>
              </ul>
              <p>Users agree to comply with all applicable marketplace requirements.</p>
              <h3>18.5 Marketplace Billing</h3>
              <p>Where subscriptions or in-app purchases are offered through a marketplace:</p>
              <ul>
                <li>billing may be administered by the marketplace;</li>
                <li>renewals may be processed by the marketplace;</li>
                <li>cancellations may be processed by the marketplace;</li>
                <li>refunds may be governed by marketplace rules; and</li>
                <li>payment disputes may be governed by marketplace policies.</li>
              </ul>
              <p>The Company shall not be responsible for actions taken by a marketplace operator in connection with billing activities.</p>
              <h3>18.6 Marketplace Account Requirements</h3>
              <p>Use of certain App features may require:</p>
              <ul>
                <li>an Apple account;</li>
                <li>a Google account;</li>
                <li>a marketplace account; or</li>
                <li>another authorized third-party account.</li>
              </ul>
              <p>Users are responsible for maintaining such accounts in good standing.</p>
              <p>The Company shall not be responsible for:</p>
              <ul>
                <li>account suspensions;</li>
                <li>account restrictions;</li>
                <li>account terminations;</li>
                <li>credential issues; or</li>
                <li>actions taken by marketplace operators.</li>
              </ul>
              <h3>18.7 Device and Operating-System Requirements</h3>
              <p>The App may require:</p>
              <ul>
                <li>supported operating systems;</li>
                <li>supported hardware;</li>
                <li>specific device capabilities;</li>
                <li>marketplace software; or</li>
                <li>minimum software versions.</li>
              </ul>
              <p>The Company does not guarantee compatibility with all devices or future operating-system releases.</p>
              <h3>18.8 Marketplace Changes</h3>
              <p>Marketplace operators may modify:</p>
              <ul>
                <li>policies;</li>
                <li>requirements;</li>
                <li>APIs;</li>
                <li>billing procedures;</li>
                <li>privacy requirements;</li>
                <li>technical requirements;</li>
                <li>approval standards; or</li>
                <li>distribution rules</li>
              </ul>
              <p>at any time.</p>
              <p>The Company reserves the right to modify the App or these Terms to comply with marketplace requirements.</p>
              <h3>18.9 Removal from Marketplaces</h3>
              <p>The Company may:</p>
              <ul>
                <li>remove the App from a marketplace;</li>
                <li>suspend distribution;</li>
                <li>discontinue availability in specific jurisdictions;</li>
                <li>discontinue support for certain devices; or</li>
                <li>discontinue support for specific operating systems</li>
              </ul>
              <p>at any time.</p>
              <p>The Company shall not be liable for any loss arising from such actions.</p>
              <h3>18.10 Compliance with Export and Sanctions Laws</h3>
              <p>Users represent and warrant that they are not:</p>
              <ul>
                <li>located in a jurisdiction subject to comprehensive trade sanctions that prohibit use of the App;</li>
                <li>listed on any governmental prohibited-party list applicable to the App; or</li>
                <li>otherwise prohibited from receiving the App under applicable export-control laws.</li>
              </ul>
              <p>Users agree not to export, re-export, transfer, or make the App available in violation of applicable export-control or sanctions laws.</p>
              <h3>18.11 Marketplace Enforcement</h3>
              <p>The Company may suspend or terminate access where required to comply with:</p>
              <ul>
                <li>marketplace policies;</li>
                <li>marketplace enforcement actions;</li>
                <li>marketplace investigations;</li>
                <li>marketplace security requirements;</li>
                <li>marketplace legal requirements; or</li>
                <li>marketplace compliance obligations.</li>
              </ul>
              <p>The Company shall not be liable for actions reasonably taken to maintain marketplace compliance.</p>
              <h3>18.12 Future Distribution Channels</h3>
              <p>The Company may distribute the App through additional marketplaces, app stores, web-based platforms, desktop applications, or other distribution channels in the future.</p>
              <p>Additional distribution channels may be subject to supplemental terms and conditions.</p>
              <h3>18.13 Survival</h3>
              <p>The provisions of this Section shall survive:</p>
              <ul>
                <li>termination of these Terms;</li>
                <li>termination of a user’s account;</li>
                <li>removal of the App from a marketplace;</li>
                <li>discontinuation of the App; and</li>
                <li>cessation of the relationship between the parties.</li>
              </ul>
              <p>19. Contact Us</p>
              <h3>19.1 General Inquiries</h3>
              <p>Questions regarding the App, these Terms, subscriptions, billing, Child Profiles, Parent Accounts, Analytics Features, or general support may be directed to:</p>
              <p>2422019 Ontario Inc. (o/a BuckTime!)</p>
              <p>Email: support@chachingapp.ca</p>
              <p>Website: www.chachingapp.ca</p>
              <p>The Company may update its contact information from time to time by posting revised information within the App or on its website.</p>
              <h3>19.2 Privacy and Child Privacy Requests</h3>
              <p>Requests concerning:</p>
              <ul>
                <li>privacy rights;</li>
                <li>personal information;</li>
                <li>Child Profiles;</li>
                <li>parental consent;</li>
                <li>withdrawal of consent;</li>
                <li>access requests;</li>
                <li>correction requests;</li>
                <li>deletion requests;</li>
                <li>data portability requests; or</li>
                <li>privacy complaints</li>
              </ul>
              <p>may be submitted to:</p>
              <p>Email: privacy@chachingapp.ca</p>
              <p>The Company may require reasonable verification of identity and authority before responding to any request.</p>
              <h3>19.3 Legal Notices</h3>
              <p>Formal legal notices, dispute notices, intellectual property complaints, regulatory inquiries, subpoenas, court documents, or other legal communications may be directed to:</p>
              <p>Email: legal@chachingapp.ca</p>
              <p>Delivery of a notice by email shall not be effective unless receipt is acknowledged by the Company or otherwise required by applicable law.</p>
              <p>The Company reserves the right to designate additional methods for service of legal notices.</p>
              <h3>19.4 Security Reports</h3>
              <p>Suspected security incidents, unauthorized access, cybersecurity concerns, fraud reports, misuse reports, or reports of unauthorized monitoring may be submitted to:</p>
              <p>Email: security@chachingapp.ca</p>
              <p>The Company may investigate reported concerns and take actions it considers appropriate to protect users, children, the App, and the Company’s systems.</p>
              <h3>19.5 Response Times</h3>
              <p>The Company will use commercially reasonable efforts to review and respond to communications; however, the Company does not guarantee any specific response time.</p>
              <p>Response times may vary depending on:</p>
              <ul>
                <li>the nature of the request;</li>
                <li>verification requirements;</li>
                <li>legal obligations;</li>
                <li>complexity of the matter; and</li>
                <li>operational circumstances.</li>
              </ul>
              <h3>19.6 No Emergency Communications</h3>
              <p>The App and the contact methods identified in this Section are not emergency services.</p>
              <p>Users must not rely upon the App or Company contact channels for:</p>
              <ul>
                <li>emergency assistance;</li>
                <li>child-safety emergencies;</li>
                <li>medical emergencies;</li>
                <li>law-enforcement emergencies; or</li>
                <li>time-sensitive emergency situations.</li>
              </ul>
              <p>In the event of an emergency, users should immediately contact the appropriate emergency services or local authorities.</p>
              <h3>19.7 Electronic Communications</h3>
              <p>By contacting the Company, users consent to receiving responses electronically, including by:</p>
              <ul>
                <li>email;</li>
                <li>in-App message;</li>
                <li>website communication;</li>
                <li>support ticket system; or</li>
                <li>other electronic means.</li>
              </ul>
              <p>Electronic communications satisfy any requirement that communications be provided in writing.</p>
              <h3>19.8 Changes to Contact Information</h3>
              <p>The Company reserves the right to modify its contact information at any time.</p>
              <p>Updated contact information will be posted within the App, on the Company’s website, or through other reasonable means.</p>
              <p>Users are responsible for consulting the most current version of these Terms for updated contact information.</p>
              <p>These Terms of Service were last updated on May 26, 2026. Please retain a copy for your records.</p>

          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default TermsPage;
